export const TRANSLATIONS_ES_AR = {
    "In force": "Vigentes",
    "New proposal": "Nueva propuesta",
    "Number of ads": "Cantidad de anuncios",
    "For a total amount of": "Por un monto total de",
    "Finalization": "Finalización",
    "Condition": "Condición",
    "Valid": "Vigente",
    "Expired": "Vencida",
    "Real spots": "Playouts reales",
    "Purchased spots": "Playouts comprados",
    "Screens quantity": "Cantidad de pantallas",
    "Created by": "Creada por",
    "Created on": "Creada el",
    "DSP": "DSP",
    "Traditional campaign": "Campaña tradicional",
    "Relaunch": "Replicar",
    "Delete payment": "Eliminar pago",
    "Are you sure you want to delete this payment?": "¿Seguro que querés eliminar este pago?",
    "There is already a pending payment for this campaign.": "Ya existe un pago pendiente para esta campaña.",
    "Screens map": "Mapa de pantallas",
    "Ads per screen": "Anuncios por pantalla",
    "Ad": "Anuncio",
    "There are no rules applied to this ad": "No hay reglas aplicadas en este anuncio",
    "The owner of this screen does not use cms": "El Media Owner de esta pantalla no usa cms",
    "New campaign": "Nueva campaña",
    "Select client": "Seleccionar cliente",
    "Archive": "Archivar",
    "Unarchive": "Desarchivar",
    "Duplicate": "Duplicar",
    "Approved ads": "Anuncios aprobados",
    "Grid view": "Vista de cuadrícula",
    "List view": "Vista de lista",
    "Operation completed successfully": "Operación realizada con éxito",
    "This action cannot be undone.": "Esta acción no se puede deshacer.",
    "Do you want to archive this campaign?": "¿Querés archivar esta campaña?",
    "Do you want to unarchive this campaign?": "¿Querés desarchivar esta campaña?",
    "This function is not available yet": "Esta función todavía no está disponible",
    "Welcome to React": "ES",

    //Language
    "es": "Español",
    "es_ar": "Español (Argentina)",
    "en": "English",
    "Search": "Buscar",
    "language iso 639-1": "ES",

    // Buttons
    "Continue": "Continuar",
    "Accept": "Aceptar",

    // Top bar component
    "I offered your screens": "Ofrecé tus pantallas",
    "Screen manager": "CMS",
    "My campaigns": "Mis campañas",
    "My proposals": "Mis propuestas",
    "Daily consumption of the campaign": "Consumo diario de la campaña",
    "Total consumption of all screens (per day)": "Suma total del consumo de todas las pantallas (por día)",
    "Total campaign": "Total campaña",
    "consumption_per_day": "Consumo en {{currency}} por día",
    "consumption_accumulated": "Consumo en {{currency}} acumulado",
    "Go to CMS": "Ir al CMS",
    "My profile": "Mi perfil",
    "Sign off": "Cerrar sesión",
    "Sign up": "Registrate",
    "Sign up as an agency": "Registrate como agencia",
    "Sign up as an advertiser": "Registrate como anunciante",
    "Log in": "Iniciá sesión",
    "Login": "Ingresá",
    "Agency Account": "Cuenta Agencia",
    "My quotes": "Mis cotizaciones",
    "Password": "Contraseña",
    "Password must be at least 6 characters": "La contraseña debe tener al menos 6 caracteres",

    "Code2FA": "Código de seguridad",
    "To log in, you must enable two-factor authentication (2FA) by accessing the CMS.": "Para iniciar sesión debes habilitar la autenticación de dos factores (2FA) ingresando al CMS.",
    "I forgot my password": "Olvidé mi contraseña",
    "Dont have an account?": "¿No tenés una cuenta?",
    "Do you already have your account?": "¿Ya tenés tu cuenta?",
    "Are you a media owner?": "¿Sos Media Owner?",
    "Register here": "Registrate acá",
    "Create company account": "Crear cuenta empresa",
    "Recover your password": "Recuperá tu contraseña",
    "Enter your email and we will send you the instructions to reset your password.": "Ingresá tu correo y te enviaremos las instrucciones para resetear tu contraseña.",
    "Send instructions": "Enviar instrucciones",
    "Resend verification email": "Reenviar correo de verificación",
    "Enter your email and we will resend you the verification instructions.": "Ingresa tu correo y te enviaremos las instrucciones para verificar tu cuenta.",
    "Resend email": "Reenviar correo",
    "Name": "Nombre",
    "First Name": "Nombre",
    "Last name": "Apellido",
    "Phone": "Teléfono",
    "Data entered correctly, we will send you an email when we confirm your data.": "Datos ingresados correctamente, te enviaremos un mail cuando confirmemos tus datos.",
    "Session closed successfully": "Sesión cerrada correctamente",
    "Welcome": "Bienvenido",
    "Error sending email": "Error al enviar el email",
    "Selected screens must have the same currency": "Las pantallas seleccionadas deben tener la misma moneda",
    "Good! An email was sent to your mailbox to retrieve your password.": "¡Bien! Se envió un email a tu casilla para recuperar tu contraseña.",
    "Good! An email was sent to your mailbox to activate yout account.": "¡Bien! Se envió un email a tu casilla para activar tu cuenta.",
    "Good! Just one step left, activate your account.": "¡Bien! Solo falta un paso, activa tu cuenta",
    "Good! You just need to verify your email": "¡Bien! Solo falta que verifiques tu email",
    "To begin you must verify your email. Check your email box to complete the registration process. Remember to check your spam folder.": "Para comenzar debes verificar tu email. Revisa tu casilla de correo para completar el proceso de registro. Recuerda revisar la carpeta de correo no deseado.",
    "In order to use your account you have to activate it. Check your email address to finish the registration process.": "Para usar tu cuenta debes activarla. Consulte su casilla de correo para finalizar el proceso de registro. Recuerda revisar la carpeta de correo no deseado.",
    "Url whatsapp, Hello, I would like to have advice publinet": "https://api.whatsapp.com/send?phone=5492615019508&text=Hola,%20me%20gustaría%20tener%20asesoramiento.%20",
    "Url whatsapp, Hello, I would like to have advice latinad": "https://api.whatsapp.com/send?phone=5492615019508&text=Hola,%20me%20gustaría%20tener%20asesoramiento.%20",
    "Url whatsapp, Hello, I would like to have advice fenix": "https://api.whatsapp.com/send?phone=14073752728&text=Hi,%20I%20would%20like%20to%20have%20advice.",
    "Url whatsapp, Hello, I would like to have advice mediashake": "https://api.whatsapp.com/send?phone=573107964234&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20MediaShake...",
    "Url whatsapp, Hello, I would like to have advice duoprint": "https://api.whatsapp.com/send?phone=593999560300&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20DuoPrint...",
    "Url whatsapp, Hello, I would like to have advice hak media": "https://api.whatsapp.com/send?phone=56935574177&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20%20Hakmedia...",
    "Currency": "Moneda",
    "Terms": "Términos y condiciones",
    "Content Manager System": "Gestor de contenido",
    "Screen Player": "Reproductor de pantallas",
    "Supply Side Platform": "Plataforma de ventas online",
    "Audience measurement": "Medición de audiencia",
    "Static OOH platform": "Plataforma de estáticos OOH",

    // Footer
    "You can start creating your campaign by entering the zone and date.": "Podés comenzar a crear tu campaña colocando zona y fecha.",
    "Advertisers": "Anunciantes",
    "Create campaign": "Crear campaña",
    "I am an agency": "Soy una Agencia",
    "Purchase advice": "Asesoramiento en compra",

    "Offer your screens": "Ofrecé tus pantallas",
    "SSP": "SSP",
    "Product": "Producto",
    "Certifications": "Certificaciones",
    "Community": "Comunidad",
    "Success cases": "Casos de éxito",
    "Plan your campaign": "Planifica tu campaña",
    "in the right place": "en el lugar correcto",
    "Technological solutions for the DOOH industry": "Soluciones tecnológicas para la industria del DOOH",

    "Contact": "Contacto",
    "Write us by whatsapp": "Escribinos por whatsapp",
    "Speak with us": "Hablá con nosotros",
    "Work with us": "Trabajá con nosotros",
    "Help": "Ayuda",

    // TODO: not implemented
    "Hello, I would like to work with you. I leave information about me:": "Hola, me gustaría trabajar con ustedes. Les dejo información sobre mi:",

    "Url whatsapp, I am an agency publinet": "https://api.whatsapp.com/send?phone=5492615019508&text=Hola,%20tengo%20una%20agencia%20y%20me%20gustar%C3%ADa%20poder%20operar%20a%20trav%C3%A9s%20de%20la%20plataforma.",
    "Url whatsapp, I am an agency latinad": "https://api.whatsapp.com/send?phone=5492615019508&text=Hola,%20tengo%20una%20agencia%20y%20me%20gustar%C3%ADa%20poder%20operar%20a%20trav%C3%A9s%20de%20la%20plataforma.",

    "Url whatsapp, Purchase advice publinet": "https://api.whatsapp.com/send?phone=5492615019508&text=Hola,%20quiero%20hacer%20una%20campa%C3%B1a%20y%20me%20gustar%C3%ADa%20tener%20asesoramiento.",
    "Url whatsapp, Purchase advice latinad": "https://api.whatsapp.com/send?phone=5492615019508&text=Hola,%20quiero%20hacer%20una%20campa%C3%B1a%20y%20me%20gustar%C3%ADa%20tener%20asesoramiento.",

    "Mailto Work with us": "mailto:info@latinad.com?subject=Quiero trabajar con ustedes&amp;body=Hola, me gustaría trabajar con ustedes. Les dejo información sobre mi:",

    "Our social networks": "Nuestras redes",
    "Find out about the latest news of the platform on our social networks.": "Enterate de las últimas novedades de la plataforma en nuestras redes sociales.",

    // SearchBoxComponent
    "Campaign location": "Zona de campaña",
    "Add Country or City?": "¿A dónde la apuntas?",
    "Campaign start": "Inicio campaña",
    "End of campaign": "Fin campaña",
    "Add dates": "Agregá las fechas",
    "Select a customer and brand to continue": "Seleccione un cliente y una marca para continuar",
    "Enter brief to continue": "Ingrese brief para continuar",
    "Traditional": "Tradicional",
    "Programmatic": "Programática",
    "Classic version": "Versión clásica",
    "AI Planner": "IA Planner",
    "Campaign brief": "Brief de la campaña",
    "Optimize brief": "Optimizar brief",
    "IA Brief": "IA Brief",
    "New brief": "Nuevo brief",
    "Continue with this brief": "Continuar con este brief",
    "Optimizing brief...": "Optimizando brief...",
    "Error optimizing brief": "Error al optimizar el brief",
    "Skip": "Saltar paso",
    "Client": "Cliente",
    "Mark": "Marca",
    "": "",
    "To select a client, you must first create it in the “Clients” section of the CMS and then create the associated brand. Click on the <icon/> to learn how to do it.": "Para seleccionar un cliente, debes primero crearlo en la sección “Clientes” del CMS y luego crear la marca asociada.  Hacé click en el <icon/>  para aprender cómo hacerlo.",

    //CampaignModal
    "Dark mode": "Modo oscuro",
    "Light mode": "Modo claro",
    "Theme": "Tema",
    "Campaign Information": "Información de campaña",
    "Configure the basic details of your campaign": "Configure los detalles básicos de su campaña publicitaria",
    "Add campaign zone": "Agregar zona de campaña",
    "Campaign amount": "Presupuesto de la campaña",
    "Next step": "Siguiente",
    "Back": "Anterior",
    "Done": "Hecho",
    "Segmentation": "Segmentación",
    "segmented": "segmentada",
    "inclusive": "inclusiva",
    "Define your audience's demographics and points of interest": "Defina la demografía y puntos de interés de su audiencia",
    "Men": "Hombres",
    "Women": "Mujeres",
    "Ages": "Edades",
    "Points of interest": "Puntos de interés",
    "Add point of interest": "Agregar puntos de interés",
    "Types of screens": "Tipos de pantallas",
    "Types": "Tipos",
    "types": "tipos",
    "Specify the types and subtypes of screens to use": "Especifique los tipos y subtipos de pantallas a utilizar",
    "Explore proposals": "Explorar propuestas",
    "Creating proposals": "Creando propuestas",
    "AI_justification_hint": "Haz clic en el ícono junto a cada sección para obtener justificaciones de la IA",
    "loading_justifications": "Cargando justificaciones IA...",
    "Objectives": "Objetivos",
    "Strategy": "Estrategia",
    "Justification": "Justificación",
    "The sum of men and women must equal 100%": "El total de hombres y mujeres debe ser 100%",
    "The total for all brackets must equal 100%": "El total de todos los brackets debe ser 100%",
    "How do you want to work today?": "¿Cómo quieres trabajar hoy?",

    //Brackets
    "Level": "Nivel",
    "LEVEL_A_INFO": "El nivel socioeconómico más alto, que incluye a individuos con ingresos muy altos, educación avanzada y ocupaciones de alto estatus. Este grupo suele tener un alto poder adquisitivo y acceso a bienes y servicios de lujo.",
    "LEVEL_B_INFO": "Este nivel incluye a individuos con ingresos altos, pero no tan elevados como el nivel A. Suelen tener una buena educación y ocupaciones de estatus medio-alto.",
    "LEVEL_C_INFO": "Se refiere a la clase media, con ingresos y educación moderados. Las ocupaciones pueden ser de tipo administrativo, técnico o de gestión de nivel medio.",
    "LEVEL_D_INFO": "Este nivel incluye a individuos de ingresos bajos a moderados, con menor nivel educativo y ocupaciones de menor estatus. A menudo, este grupo enfrenta ciertas limitaciones en su poder adquisitivo.",
    "LEVEL_E_INFO": "El nivel socioeconómico más bajo, que incluye a individuos con ingresos muy bajos, educación básica y ocupaciones de bajo estatus o desempleo. Este grupo suele tener un acceso limitado a bienes y servicios.",

    "years": "años",
    "CHILDREN": "Niños",
    "CHILDREN_INFO": "0-14 años",
    "TEENS": "Adolescentes",
    "TEENS_INFO": "15-19 años",
    "YOUNG_ADULTS": "Ads. jóvenes",
    "YOUNG_ADULTS_INFO": "20-29 años",
    "MIDLIFE_ADULTS": "Ads. med. edad",
    "MIDLIFE_ADULTS_INFO": "30-44 años",
    "MATURE_ADULTS": "Ads. mayores",
    "MATURE_ADULTS_INFO": "45-54 años",
    "SENIOR": "Senior",
    "SENIOR_INFO": "55 años en adelante",

    // HomeComponent
    "Digital signage": "Cartelería Digital",
    "Digital signage (DOOH)": "Cartelería Digital (DOOH)",
    "High-Value Audiences at a Click": "Audiencias de alto valor a un click",
    "Boost your brand": "Potenciá tu marca",
    "Create campaigns on public roads in minutes and reach thousands of people": "Creá campañas en vía pública en minutos y llegá a miles de personas",
    "Strategically positioned where your ideal audience is.": "Estratégicamente posicionados donde está tu audiencia ideal.",
    "All you need to plan and manage Digital Out Of Home campaigns, in one place.": "Todo lo que necesitás para planificar y gestionar campañas de Digital Out Of Home, en un solo lugar.",
    "Get to know us": "Conocenos",
    "Discover the latest in outdoor advertising": "Descubrí lo último en publicidad exterior",
    "Communicate your brand to thousands of people intelligently": "Comunicá tu marca a miles de personas de forma inteligente",
    "Without intermediaries": "Sin intermediarios",
    "Without calls": "Sin llamadas",
    "100% Online": "100% Online",
    "Do you have screens?": "¿Tenés pantallas?",
    "Join the largest network in America, manage your business and increase sales.": "Sumate a la red más grande de América, gestioná tu negocio y aumentá las ventas.",
    "Register as media company": "Registrate",
    "I dont have CMS": "No tengo CMS y quiero ver los beneficios",
    "I have CMS": "Tengo CMS, solo quiero aumentar mis ventas",
    "Know the media details": "Conocé los detalles",
    "Audience measurement with artificial intelligence": "Medición de audiencia con inteligencia artificial",
    "Our campaigns are based on traffic and people metrics. Find out how we do it.": "Nuestras campañas están basadas en métricas de tráfico y personas. Enterate como lo hacemos.",
    "Know the audience details": "Conocé los detalles",
    "Partners": "Partners",
    "Blog": "Noticias y Blog",
    "Text Blog 1": "Crea campañas en LatinAd para +150 DSPs",
    "Description Blog 1": "Lanza campañas en DOOH comprando todos los medios disponibles en Latinoamérica y accediendo a más de 150 DSPs.",
    "Text Blog 2": "Planifica en Latinad e implementa en DSPs externos",
    "Description Blog 2": "Lee la nota completa - 04/07/2022",
    "Text Blog 3": "Te compartimos el tutorial.",
    "Description Blog 3": "Help te enseñará de Latinad.",
    "Platform integrated to the DOOH and programmatic Ecosystem": "Plataforma integrada al Ecosistema DOOH y programático",
    "You must be logged in to see the price": "Debe estar logueado para ver el precio",

    // Info
    // "Watch our video": "Mirá nuestro video",
    // "You are part of the OOH advertising world on. Learn here.": "Formas parte del mundo publicitario en vía pública, mirá este video",
    // "3 Simple Steps to start your campaign": "3 Simples pasos",
    // "It is everything you need to launch your campaign on public roads": "Es todo lo que necesitas para lanzar tu campaña en vía pública",
    // "Do you have screens?": "¿Tenés pantallas?",
    // "Join the largest Out of Home network in America": "Unite a la red más grande de pantallas de América",

    // Expansion
    "Where we are?": "¿Dónde estamos?",
    "Argentina": "Argentina",
    "Peru": "Perú",
    "Ecuador": "Ecuador",
    "Colombia": "Colombia",
    "Central America": "Centro América",
    "Chile": "Chile",
    "Mexico": "México",
    "US": "Estados Unidos",

    // UserSettingComponent
    "Account": "Cuenta",
    "Agency": "Agencia",
    "Profile information": "Información del perfil",
    "User": "Usuario",
    "Email address": "Correo electrónico",
    "Profile photo": "Foto del perfil",
    "Change profile photo": "Cambiar foto de perfil",
    "Only image files are allowed": "Solo se permiten archivos de imagen",
    "The image must be smaller than 2MB": "La imagen debe pesar menos de 2MB",
    "Could not update the profile photo": "No se pudo actualizar la foto de perfil",
    "Agency data": "Datos de la agencia",
    "Business name": "Razón social",
    "Tax ID": "Cuit/Rut/Nit",
    "Associated brands": "Marcas asociadas",
    "You have no associated clients yet": "Todavía no tenés clientes asociados",
    "Mail": "Correo",
    "Change Mail": "Cambiar Correo",
    "New Mail": "Nuevo Email",
    "Change Password": "Cambiar Contraseña",
    "Current Password": "Contraseña actual",
    "New Password": "Nueva Contraseña",
    "Repeat New Password": "Repetir Nueva Contraseña",
    "Repeat the old password": "Repetir la contaseña anterior.",

    // QuotesComponent
    "Quotes": "Cotizaciones",
    "Sub type": "Subtipo",
    "Not assigned": "No asignado",
    "See quote": "Ver cotización",
    "Delete quote": "Eliminar cotización",
    "Unarchived quote": "Desarchivar cotización",
    "Archived quote": "Archivar cotización",
    "Quote removed successfully": "Cotización eliminada con éxito",
    "Quote archived successfully": "Cotización archivada con éxito",
    "Quote unarchived successfully": "Cotización desarchivada con éxito",
    "An error occurred while trying to delete quote": "Ocurrió un error al intentar eliminar cotización",
    "An error occurred while trying to update quote": "Ocurrió un error al intentar editar la cotización",
    "Quote updated successfully": "Cotización editada con éxito",
    "Minumum budget": "The budget must be greater than ",
    "Created": "Creado",
    "Start": "Inicio",
    "StartSearch": "Comenzar",
    "End": "Fin",
    "Qty. Screens": "Cant. Pantallas",
    "Action": "Acción",

    // CampaignsComponent
    "Campaign successfully removed": "Campaña eliminada con éxito",
    "You cannot delete campaigns with payments created": "No puede eliminar campañas con pagos creados",
    "No campaigns": "No hay campañas",
    "No proposal has been generated": "No hay propuestas generadas",
    "An error occurred while deleting campaign": "Ocurrió un error al eliminar campaña",
    "There is no client": "No existe cliente",
    "There is no brand": "No existe marca",
    "Getting campaigns": "Obteniendo campañas",
    "You havent created your first campaign yet.": "Todavía no creaste tu primer campaña.",
    "Still to be paid": "Pendientes de pago",
    "Pending approval": "Pendientes de aprobación",
    "Active": "Activas",
    "Next": "Próximas",
    "Previous": "Pasadas",
    "Proposals": "Propuestas",
    "Archived": "Archivadas",
    "Atention!": "Atención!",
    "You are about to delete a campaign. Are you agree?": "Está a punto de eliminar una campaña. ¿Esta de acuerdo?",
    "You are about archived a {type}, then you can unarchived in seccion archived": "Está a punto de archivar una {type}, luego puede desarchivarla en la sección archivadas",
    "You are about unarchive a {type}": "Está a punto de desarchivar una {type}",
    "OK": "Aceptar",
    "Confirm": "Confirmar",
    "Once you proceed to step 2, you won’t be able to change the creation type (campaign or proposal) without losing your settings.": "Una vez que avance al paso 2, no podrá cambiar el tipo de creación (campaña o propuesta) sin perder sus configuraciones.",
    "To modify this campaign, use the new version of the DSP with which it was created": "Para modificar esta campaña, utilice la nueva versión del DSP con la que fue creada",
    "New version": "Nueva versión",
    "Version": "Versión",
    "Are you sure you want to delete this relationship?": "¿Estás seguro de que deseas eliminar esta relación?",
    "Manage ads and screens": "Administrar Anuncios y Pantallas",
    "Ad library": "Librería de anuncios",
    "My ads": "Mis anuncios",
    "Search ads": "Buscar anuncios",
    "Upload ad": "Subir anuncio",
    "New folder": "Nueva carpeta",
    "No ads yet": "Aún no hay anuncios",
    "Brands": "Marcas",
    "Clients": "Clientes",
    "No clients selected. Please select one": "No hay clientes seleccionados. Por favor seleccioná uno",
    "No clients available": "No hay clientes disponibles",
    "No brands available": "No hay marcas disponibles",
    "Brand": "Marca",
    "Folder": "Carpeta",
    "Select a client and a brand to view their ads": "Seleccioná un cliente y una marca para ver sus anuncios",
    "Select a folder to view its ads": "Seleccioná una carpeta para ver sus anuncios",
    "All ads": "Todos los anuncios",
    "Creation date": "Fecha de creación",
    "Items": "Items",
    "Actions": "Acciones",
    "Folders": "Carpetas",
    "Ads": "Anuncios",
    "Select folder": "Seleccionar carpeta",
    "Deselect folder": "Deseleccionar carpeta",
    "Sort": "Ordenar por",
    "Most recent": "Más recientes",
    "Oldest": "Más antiguos",
    "Ad type": "Tipo de anuncio",
    "Ad status": "Estado del anuncio",
    "Available": "Disponible",
    "In use": "En uso",
    "items": "elementos",
    "Select a brand": "Selecciona una marca",
    "Choose one of the folders above (for example, {{first}} or {{second}}) to view and manage its ads.": "Elige una de las carpetas de arriba (por ejemplo, {{first}} o {{second}}) para ver y gestionar sus anuncios.",
    "Choose one of the folders above (for example, {{first}}) to view and manage its ads.": "Elige una de las carpetas de arriba (por ejemplo, {{first}}) para ver y gestionar sus anuncios.",
    "Choose one of the folders above to view and manage its ads.": "Elige una de las carpetas de arriba para ver y gestionar sus anuncios.",
    "Rename": "Renombrar",
    "ContentsTag errors.": "Ya existe una carpeta con este nombre.",
    "Rename ad": "Renombrar anuncio",
    "Rename folder": "Renombrar carpeta",
    "Create new folder": "Crear nueva carpeta",
    "Folder name": "Nombre de la carpeta",
    "e.g. Summer Promo Banner": "Ej: Banner Promocional Verano",
    "Create folder": "Crear carpeta",
    "Upload new ad": "Subir nuevo anuncio",
    "Upload file": "Subir archivo",
    "Upload {{count}} files": "Subir {{count}} archivos",
    "{{count}} files selected": "{{count}} archivos seleccionados",
    "Click to upload or drag your files here": "Hacé clic para subir o arrastrá tus archivos aquí",
    "Supports JPG, PNG, MP4, MP3 (Max 500MB)": "Soporta JPG, PNG, MP4, MP3 (Máx 500MB)",
    "Drop files to upload": "Soltá los archivos para subirlos",
    "Uploading {{name}}…": "Subiendo {{name}}…",
    "{{name}} uploaded": "{{name}} subido",
    "Could not upload {{name}}": "No se pudo subir {{name}}",
    "They will be saved in {{folder}}": "Se guardarán en <strong>{{folder}}</strong>",
    "Brand / Folder": "Marca / Carpeta",
    "Archive folder": "Archivar carpeta",
    "Are you sure you want to archive this folder?": "¿Seguro que querés archivar esta carpeta?",
    "This tag already exist in this folder.": "Ya existe una carpeta con ese nombre en esta ubicación.",
    "Archive ad": "Archivar anuncio",
    "Are you sure you want to archive this ad? This action cannot be undone.": "¿Seguro que querés archivar este anuncio? Esta acción no se puede deshacer.",
    "Archive {{count}} items": "Archivar {{count}} elementos",
    "Archive items": "Archivar elementos",
    "Are you sure you want to archive the {{count}} selected items? This action cannot be undone.": "¿Seguro que querés archivar los {{count}} elementos seleccionados? Esta acción no se puede deshacer.",
    "{{count}} selected": "{{count}} seleccionados",
    "Clear selection": "Limpiar selección",
    "Campaign Ads": "Anuncios para la campaña",
    "The ad will be detached from the group of screens of this resolution and will no longer be used in the campaign. You can add it again later.": "Se desvinculará el anuncio del grupo de pantallas de esta resolución y se dejará de usar en la campaña. Puede agregarlo nuevamente después.",
    "The ad will be unlinked from this screen. You can add it again later.": "Se desvinculará el anuncio de esta pantalla. Puede agregarlo nuevamente después.",
    "The ad will be unlinked from this group of screens. You can add it again later.": "Se desvinculará el anuncio de este grupo de pantallas. Puede agregarlo nuevamente después.",
    "This ad is not linked to another screen, so it will no longer be used in the campaign.": "Este anuncio no está vinculado a otra pantalla, por lo que dejará de usarse en la campaña.",
    "The ad will be unlinked from the group of screens for this resolution. Since it is not linked to any other screen, it will no longer be used in the campaign. You can add it again later.": "Se desvinculará el anuncio del grupo de pantallas de esta resolución. Este anuncio no está vinculado a otra pantalla, por lo que dejará de usarse en la campaña. Puede agregarlo nuevamente después.",
    "The ad will be unlinked from this screen. This ad is not linked to any other screen, so it will no longer be used in the campaign. You can add it again later.": "Se desvinculará el anuncio de esta pantalla. Este anuncio no está vinculado a otra pantalla, por lo que dejará de usarse en la campaña. Puede agregarlo nuevamente después.",
    "The ad will be unlinked from this group of screens. This ad is not linked to any other screen, so it will no longer be used in the campaign. You can add it again later.": "Se desvinculará el anuncio de este grupo de pantallas. Este anuncio no está vinculado a otra pantalla, por lo que dejará de usarse en la campaña. Puede agregarlo nuevamente después.",
    "Are you sure you want to delete this ad from the library? You will need to upload it again if you want to use it again.": "¿Está seguro de que desea eliminar este anuncio de la biblioteca? Deberá cargarlo nuevamente si desea volver a utilizarlo.",
    "Are you sure you want to actionText?": "¿Estás seguro de que quieres actionText?",
    "All current progress will be lost": "Todos los cambios realizados <strong>se perderán permanentemente</strong>.",

    // CampaignsCard
    "Ads rejected": "Aviso(s) rechazado(s)",
    "See detail": "Ver detalle",
    "Report": "Reporte",
    "View report": "Ver reporte",
    "Campaign created by": "Campaña creada por",
    "the day": "El día",
    "at": "a las",
    "for a total amount of": "Por un monto total de",
    "Price breakdown": "Desglose de precios",
    "Media investment": "Inversión en medios",
    "LatinAd commission": "Comisión LatinAd",
    "Partner commission": "Comisión Partner",
    "DSP commission": "Comisión DSP",
    "Exchange commission": "Comisión Exchange",
    "Agency commission": "Comisión Agencia",
    "Taxes": "Impuestos",
    "National taxes": "Impuestos nacionales",
    "International taxes": "Impuestos internacionales",
    "Subtotal without taxes": "Subtotal sin impuestos",
    "Total with taxes": "Total con impuestos",
    "Includes adjustment rate": "Incluye tasa de ajuste",
    "This chart does not include taxes": "Este gráfico no incluye impuestos",
    "Could not load the price breakdown": "No se pudo cargar el desglose de precios",
    "Delete campaign": "Eliminar campaña",
    "Archive campaign": "Archivar campaña",
    "Unarchive campaign": "Desarchivar campaña",
    "Archive proposal": "Archivar propuesta",
    "Unarchive proposal": "Desarchivar propuesta",
    "Campaign created as Programmatic": "Campaña creada como Programática",
    "Campaign created as Traditional": "Campaña creada como Tradicional",
    "Click for more information": "Click para mas información",
    "Group screens": "Agrupar pantallas",

    // CampaignsCardModal
    "See campaign": "Ver campaña",

    // Modal Select Registration Type
    "Welcome to LatinAd": "Bienvenido a LatinAd",
    "Are you an agency?": "¿Sos agencia?",
    "Are you an advertiser?": "¿Sos anunciante?",
    "Company name": "Nombre de la empresa",
    "State (optional)": "Estado (opcional)",
    "User Email": "Correo electrónico",
    "First and last name": "Nombre y apellido",
    "Phone number": "Teléfono",


    // Modal Replicate Campaign
    "Replicate campaign": "Replicar campaña",
    "Replicated": "Replicada",
    "The name is required": "El nombre es obligatorio",
    "A campaign with a pending payment status will be created, keeping the contents and screens that are still available for sale.": "Se creará una campaña con estado pendiente de pago, manteniendo los contenidos y pantallas que todavía estén a la venta",
    "The original campaign has rules based on dates, these will be removed. Remember to configure them again.": "La campaña original tiene reglas basadas en fechas, estas serán eliminadas. Recuerda configurarlas nuevamente.",

    // CampaignComponent
    "Screen resolution": "Resolución pantalla",
    "Announcement resolution": "Resolución anuncio",
    "Purchased impressions": "Playouts comprados",
    "Promised impressions": "Playouts prometidos:",
    "Screen details": "Detalles de pantalla",
    "There was an error": "Se produjo un error",
    "You do not have permissions to access this campaign": "No tiene permisos para acceder a esta campaña",
    "The requested campaign does not exist": "La campaña solicitada no existe",
    "You must first delete the pending payment before retrying a new payment": "Primero debe eliminar el pago pendiente antes de reintentar un nuevo pago",
    "Detail": "Detalle",
    "Your Ads": "Tus anuncios",
    "Your payments": "Tus pagos",
    "No payment created": "Sin pago creado",
    "Create new payment": "Crear nuevo pago",
    "Your ads for each screen": "Tus anuncios por cada pantalla",
    "See detailed report": "Ver reporte detallado",
    "The campaign will be paused, which means it will stop running and will not consume budget until it is reactivated.": "La campaña será pausada, lo que significa que dejará de exhibirse y no consumirá presupuesto hasta su reactivación. ",
    "The campaign will be activated, which means it will start running and begin consuming budget again until it is paused.": "La campaña será activada, lo que significa que comenzará a exhibirse y volverá a consumir presupuesto hasta que sea pausada.",
    "Activate campaign": "Activar campaña",
    "Edit campaign": "Editar campaña",
    "Edit proposal": "Editar propuesta",
    "View campaign in Campaign Manager": "Ver campaña en el Campaign Manager",
    "The logged-in user is not the owner of this campaign": "El usuario logueado no es dueño de esta campaña, cambie de empresa para acceder a la campaña",
    "Credit/debit card": "Tarjeta de crédito/débito",
    "MercadoPago": "MercadoPago",
    "Cash/Transfer": "Efectivo/Transferencia",
    "Approved": "Aprobado",
    "Paused": "Pausado",
    "Ready": "Activa",
    "Pending": "Pendiente",
    "Finalized": "Finalizado",
    "Processing": "Procesando",
    "Cancelled": "Cancelado",
    "Cancelled by user": "Cancelado por usuario",
    "Refunded": "Reintegrado",
    "In dispute": "En disputa",
    "Voided by claim": "Anulado por reclamo",
    "Spots pending approval of the owner of each screen": "Playouts pendientes de aprobación del Media Owner de cada pantalla",
    "Approved by the owners of each screen": "Aprobados por los Media Owners de cada pantalla",
    "Rejected": "Rechazadas",
    "To modify": "A modificar",
    "Campaign pending approval status, check with your manager.": "Campaña en estado pendiente de aprobación, consulte con su director.",
    "Campaign in pending payment status.": "Campaña en estado pendiente de pago.",
    "Exit edit mode": "Salir del modo editar",
    "Entering edit mode": "Entrando al modo de edición",
    "When entering the edit mode of a ": "Al entrar en modo edición de una ",
    "some prices may be changed ": "pueden verse modificados algunos precios ",
    "(only in cases where screen owners have updated those prices), since this campaign does not have payments generated nor has it been launched, therefore that prices have not been frozen.": "(solo en casos donde los Media Owners han actualizado esos precios), ya que esta campaña no tiene pagos generados ni ha sido ejecutada, por lo que los precios no han sido congelados.",
    "Entering campaign edit mode. This campaign has approved payment, so only elements that do not alter its price can be edited.": "Entrando al modo de edición de campaña. Esta campaña se encuentra con su pago aprobado, por lo que sólo se podrán editar aquellos elementos que no alteren el precio de la misma.",
    "Go to edit": "Ir a editar",
    "Proposal": "Propuesta",
    "Proposal updated": "Propuesta actualizada",
    "This option allows you to edit the proposal without generating a payment or changing its status.": "Esta opción permite editar la propuesta sin generar un pago ni cambiar su estado.",
    "proposal": "Propuesta",
    "Generate proposal": "Generar propuesta",
    "Campaign details": "Detalles de la campaña",
    "Category": "Categoría",

    // CampaignTopbar
    "Exhibition date": "Fechas de exhibición",
    "Duration": "Duración",
    "Real Impressions": "Playouts reales",
    "Show map": "Mostrar mapa",
    "Starts": "Comienzo",
    "Today": "Hoy",
    "Finished": "Finalizó",
    "Campaign country": "País",
    "Edit exhibition dates": "Editar fechas de exhibición",
    "Edit campaign dates warning title": "¿Deseás modificar la fecha de la campaña?",
    "Edit campaign dates warning": "Al hacerlo, <tag>todas las pantallas quedarán en estado pendiente</tag> y se irán activando a medida que se aprueben los cambios.",
    "minimum programmatic spots warning": "La inversión mínima diaria requerida para esta pantalla es de <strong>{{minimumInvestmentDaily}}</strong>.<br/>Por favor aumente la inversión para evitar el rechazo del anuncio.",
    "minimum programmatic total investment warning": "La inversión mínima total requerida para esta pantalla es de <strong>{{minimumInvestmentTotal}}</strong>.<br/>Por favor aumente la inversión para evitar el rechazo del anuncio.",
    "minimum investment breakdown": "{{minimumInvestmentDaily}} diarios corresponden a {{minimumInvestmentTotal}} en total",
    "New dates": "Nuevas fechas",
    "Campaign dates updated successfully": "Las fechas de la campaña han sido actualizadas correctamente",
    "There is a problem with the dates. Please check them and try again.": "Hay un problema con las fechas. Por favor, reviselas y vuelve a intentarlo.",
    "It is necessary for the pending date changes to be approved in order to be able to edit again.": "Es necesario que los cambios de fecha pendientes sean aprobados para poder editar nuevamente.",
    // PaymentStatusComponent
    "Cash": "Efectivo",
    "Check": "Cheque",
    "Transfer": "Transferencia",
    "Current account": "Cuenta Corriente",
    "Direct credit": "Crédito Directo",
    "Payment made through Mercado Pago with Card ending in": "Pago relaizado mediante Mercado Pago con Tarjeta terminada en",
    "Payment made by Mercado Pago": "Pago realizado por Mercado Pago",
    "Card": "Tarjeta",
    "finished in": "terminada en",
    "Unknown payment method": "Medio de pago desconocido",
    "Final consumer": "Consumidor Final",
    "Invoice": "Factura",
    "Your payment has already been approved.": "Tu pago ya fue aprobado.",
    "The payment is pending accreditation.": "El pago está pendiente de acreditación.",
    "The payment is pending payment.": "El pago está pendiente a pagar.",
    "Your payment has been credited successfully.": "Tu pago ha sido acreditado correctamente.",
    "The payment was canceled, you can generate another payment and choose the method you want.": "El pago fue cancelado, podés generar otro pago y elegir el método que quieras.",
    "We are processing your payment. In less than two business days we will notify you of the result.": "Estamos procesando su pago. En menos de dos días hábiles le notificaremos el resultado.",
    "Check the card number.": "Revisá el número de tarjeta.",
    "Please review the data and try again.": "Revisá los datos e intenta nuevamente.",
    "Check the security code.": "Revisá el código de seguridad.",
    "We were unable to process your payment. Please try another payment method.": "No pudimos procesar tu pago. Por favor, intente con otro medio de pago.",
    "Please call your card to authorize the payment and try again.": "Por favor, llama a tu tarjeta para autorizar el pago e intenta nuevamente.",
    "Your card is not active. Please call the phone number on the back of your card.": "Tu tarjeta no se encuentra activa. Por favor, llama al teléfono que está en el dorso de tu tarjeta.",
    "You already made a payment for that value. If you need to pay again, use another card or another means of payment.": "Ya hiciste un pago por ese valor. Si necesitas volver a pagar usa otra tarjeta u otro medio de pago.",
    "Your payment was declined. Choose another of the means of payment, we recommend using cash.": "Tu pago fue rechazado. Elige otro de los medios de pago, te recomendamos con medios en efectivo.",
    "Your card does not have sufficient funds to carry out the operation.": "Tu tarjeta no tiene fondos suficientes para realizar la operación.",
    "Your card cannot process installment payments.": "Tu tarjeta no puede procesar pagos en cuotas.",
    "You have reached the limit of allowed attempts. Choose another card or other means of payment.": "Llegaste al límite de intentos permitidos. Elige otra tarjeta u otro medio de pago.",
    "Start date": "Fecha de inicio",
    "Finish date": "Fecha de finalización",
    "Total campaign price": "Precio total de campaña",
    "Successful payment": "Pago realizado con éxito",
    "Pending payment": "Pago pendiente",
    "Payment canceled": "Pago cancelado",
    "Payment declined": "Pago rechazado",
    "Payment": "Pago",
    "Total without tax": "Total sin impuestos",
    "Total with tax": "Total con impuestos",
    "tax included": "imp incluído",
    "more taxation": "más impuestos",
    "+tax": "+imp",
    "Billing information": "Datos de facturación",
    "If you want to pay with another means of payment, you can return to the list of payments in your campaign, delete the pending payment, and make a new payment.": "Si quiere pagar con otro medio de pago, puede volver a la lista de pagos en su campaña, eliminar el pago pendiente, y realizar un nuevo pago.",
    "Go to my campaign": "Ir a mi campaña",
    "Summary": "Resumen",
    "See spot": "Ver anuncio",
    "Discount": "Descuento",
    "Your ads have been sent to the owners of each screen for their review and approval. This process can take up to 48 hours. We will send you a notification by mail when this process is complete.": "Tus anuncios han sido enviados a los Media Owners de cada pantalla para su revisión y aprobación. Este proceso puede tomar un tiempo de hasta 48 horas. Te enviaremos una notificación por correo cuando este proceso haya finalizado.",
    "rejected": "Rechazado",
    "View purchase orders": "Ver orden de compra",
    "Upload ODC": "Cargar ODC",
    "Campaign name placeholder": "Ingresá un nombre distintivo para identificarla",

    // AdScreenCard
    "This would modify the value of the campaign, create a new campaign or contact support": "Esto modificaría el valor de la campaña, cree una nueva campaña o contactesé con soporte",
    "The file cannot be larger than 50MB!": "El archivo no puede ser mayor a 50MB!",
    "The resolution can not be larger than 10000px": "The resolution can not be larger than 10000px",
    "successfully uploaded": "subido exitosamente",
    "You cannot upload files longer than those allowed by the programmatic": "No puede subir archivos más largos que los que permite la programática",
    "You cannot upload files longer than what is allowed on the screen": "No puede subir archivos más largos que los que se permiten en la pantalla",
    "Upload error": "Error al subir",
    "Spot Approved": "Aprobado",
    "Spot Rejected": "Rechazado",
    "Display out of service": "Pantalla fuera de servicio",
    "There is already an active date-change request for this campaign.": "Ya existe una solicitud de cambio de fecha activa para esta campaña.",
    "Change of dates not approved": "Cambio de fechas no aprobado",
    "Inactive": "Inactivo",
    "Real time impressions": "Playouts tiempo real",
    "The owner of this screen has not yet approved": "El Media Owner de esta pantalla aún no aprueba",
    "View screen details": "Ver detalles de pantalla",
    "Screen Format": "Formato de pantalla",
    "Price": "Precio",
    "Total subsidize": "Total bonificadas",
    "subsidized": "bonificadas",
    "Subsidized": "Bonificada",
    "Pre approved": "Pre aprobado",
    "Coming soon": "Próximamente",
    "Subsidize": "Bonificar",
    "Subsidize ad tooltip": "Se bonificará el CPM efectivo de este anuncio",
    "Subsidize display tooltip": "Se bonificará el CPM de pantalla",
    "Subsidize display traditional tooltip": "Se bonificará el costo por día de la pantalla",
    "Suspended": "Suspendida",
    "It will be in suspended state if the value is 0.": "Si esta pantalla queda con 0 playouts, quedara en estado suspendido (No prodra agregarle nuevos playouts)",
    "Campaign subsidized": "Bonificada",
    "Subsidize impression": "Playouts bonificados",
    "Remaining subsidized spots": "Playouts bonificados restantes",
    "Subsidized impressions": "Impresiones bonificadas",
    "Remaining subsidized impressions": "Imp. bonificadas restantes",
    "impressions subsidized/day": "imp. bonificadas / día",
    "These impressions are reflected as subsidize in the campaign": "Estas impresiones se reflejan como bonificadas en la campaña",
    "Preview": "Vista previa",
    "Preview not available": "Vista previa no disponible",
    "Change this ad for another, requires approval. Remember to upload ads of the same client, brand, campaign and similar duration.": "Cambiar este anuncio por otro, requiere aprobación. Recuerde subir anuncios del mismo cliente, marca, campaña y duración similar.",
    "Change this ad for another, requires approval. Remember to upload ads of the same client, brand, campaign and similar duration. No immediately": "Cambiar este anuncio por otro, requiere aprobación. Recuerde subir anuncios del mismo cliente, marca, campaña y duración similar. Esta acción puede tomar hasta dos horas en ser efectiva luego de la aprobación.",
    "This action will change the ad. It does require a new approval in the event that the previous ad has already been approved. Remember to upload a similar ad, from the same campaign, client and brand.": "Esta acción cambiará el anuncio. Requiere de una nueva aprobación en el caso de que ya haya sido aprobado el anuncio anterior. Recuerde subir un anuncio similar, de la misma campaña, cliente y marca.",
    "Camera to traffic": "Cámara al tráfico",
    "View live traffic": "Ver tráfico en vivo",
    "Traffic camera for audience control and measurement": "Cámara al tráfico para control y medición de audiencia",
    "You have not configured a camera pointing at traffic": "No ha configurado cámara apuntando al tráfico",
    "No data": "No hay datos",
    "Traffic today": "Tráfico de hoy",
    "Real-time vehicular traffic count": "Conteo de tráfico vehicular en tiempo real",
    "Traffic this week vs previous week": "Tráfico en esta semana vs semana anterior",
    "Weekly count by type": "Conteo semanal por tipo",
    "Movement per hour in the week": "Movimiento por hora en la semana",
    "Camera for certification": "Cámara para certificación",
    "View live screen": "Ver pantalla en vivo",
    "Camera looking at screen for certification": "Cámara mirando la pantalla para certificación",
    "You have not configured camera pointing at the screen": "No ha configurado cámara apuntando a la pantalla",
    "See evidence": "Ver evidencias",
    "Evidence": "Evidencias",
    "M": "L",
    "T": "M",
    "W": "M",
    "TH": "J",
    "F": "V",
    "SA": "S",
    "SU": "D",
    "Every day": "Todos los días",
    "All day": "Todo el día",
    "Rule": "Regla",
    "The circuit has": "El circuito tiene",
    "has multiple faces": "tiene múltiples caras",
    "have multiple faces": "tienen múltiples caras",
    "face": "cara",
    "screens_abbreviated": "pant.",

    // CartComponent
    "Quote created successfully": "Cotización creada con éxito",
    "An error occurred while trying to create a quote": "Ocurrió un error al intentar crear cotización",
    "Screen selection": "Selección de pantallas",
    "to the selection": "a la selección",
    "Estimated campaign budget": "Presupuesto estimado de campaña",
    "In the next step you will be able to configure the impressions per screen and you will see how the budget varies according to the impact you want.": "En el siguiente paso podrá configurar los playouts por pantalla y verá como varía el presupuesto según el impacto que desee.",
    "You must select a customer and brand before starting a campaign launch": "Debe seleccionar un cliente y una marca antes de comenzar el lanzamiento de una campaña",
    "You must select a customer and brand before creating a quote": "Debe seleccionar un cliente y una marca antes de crear una cotización",
    "CREATE PROPOSAL": "GENERAR COTIZACIÓN",
    "SAVE PROPOSAL": "GUARDAR COTIZACIÓN",
    "EXPORT EXCEL": "Exportar Excel",
    "EXPORT MAP": "Exportar Mapa",
    "There are no more screens in the cart": "No hay más pantallas en el carrito",
    "Empty cart": "Vaciar carrito",
    "Delete screens": "Eliminar pantallas",
    "There are no more screens selected": "No hay más pantallas seleccionadas",
    "There are no screens here": "No hay pantallas aquí",
    "screens selected": "pantallas seleccionadas",
    "Reach": "Alcance",
    "Impacts": "Impresiones",
    "Circuits": "Circuitos",
    "Imp./day": "Imp./día",
    "Faces": "Caras",
    "Total faces": "Total de caras",
    "Faces of multiple-face screens": "Caras de pantallas con múltiples caras",
    "Faces of the screens within circuits": "Caras de las pantallas dentro de circuitos",
    "Estimated budget": "Presupuesto estimado",
    "Save quote": "Guardar cotización",
    "Export Excel": "Exportar Excel",
    "Export map": "Exportar Mapa",
    "Delete selection": "Eliminar selección",
    "Create Quote": "Crear Cotización",
    "Save Quote": "Guardar Cotización",
    "The list of selected screens will be saved. You will be able to resume the campaign later from the My Quotes section.": "Se guardará el listado de pantallas seleccionadas. Podrá retomar la campaña después desde la sección Mis cotizaciones.",
    "Ads cannot be edited in approved campaigns": "No se pueden modificar anuncios en campañas aprobadas",
    "To remove this screen, advance to the next step and transfer its outputs to another screen.": "Para eliminar esta pantalla, avanzár al siguiente paso y transferí sus playouts a otra pantalla.",
    "New screen": "Nueva pantalla",
    "New screen in this group": "Nueva pantalla en este grupo",
    "New screens": "Nuevas pantallas",
    "There are new screens, transfer the budget accordingly.": "Hay pantallas nuevas, realizá el traspaso de presupuesto correspondiente.",
    "Understood": "Entendido",
    "Editing the campaign": "Editando campaña",
    "Exit edit": "Salir de editar",
    "When you exit edit mode, any changes made to screens and settings will be lost.": "Al salir del modo editar los cambios que haya hecho en pantallas y configuraciones se perderán.",
    "Slot duration": "Duración del anuncio",
    "If you exit out of edit mode, the cart and contents empty": "Saliendo del modo editar se vacia el carrito y los anuncios cargados.",
    "The minimum purchase price is not reached": "No llega al precio mínimo de compra",
    "The minimum purchase price is": "El precio mínimo de compra es",
    "Currency exchange rate": "Tasa de conversión",
    "See currency exchange rate": "Ver tasa de conversión",
    "Conversion generated at 11AM (Argentina time) today": "Conversión generada a las 11AM (hora Argentina) de hoy",
    "individual screen": "Pantalla individual",
    "individual screens": "Pantallas individuales",
    "circuit added": "Circuito agregado",
    "circuits added": "Circuitos agregados",
    "multiple face screen": "Pantalla múltiple cara",
    "multiple face screens": "Pantallas múltiples caras",
    "faces": "caras",
    "in total": "en total",

    // CheckoutDetails
    "Total cost": "Total",
    "Subtotal cost": "Subtotal",
    "Suggested price in local currency": "Precio sugerido en moneda local",
    "It is the price that you should use when implementing the campaign in the chosen DSP, only if you want to do it in local currency.": "Es el precio que debería utilizar al momento de implementar la campaña en el DSP elegido, solo en el caso que desee hacerlo en moneda local.",
    "Tax details": "Impuestos incluídos",
    "Finish": "Finalizar",
    "Finish process for subsequent approval": "Terminar proceso para su posterior aprobación",
    "By selecting this option, a payment will be generated and the proposal will be converted into a campaign.": "Al seleccionar esta opción, se generará un pago y la propuesta se convertirá en una campaña.",
    "View campaign": "Ver campaña",
    "Go Mercado Pago": "Ir a Mercado Pago",
    "Apply discount coupon": "Aplicar cupón de descuento",
    "Coupon code": "Código de Cupón",
    "Remove discount": "Eliminar descuento",

    // FiltersComponent
    "Client and brand": "Cliente / Marca",
    "Change campaign dates": "Cambiar fechas de campaña",
    "Price per day per screen": "Precio por día por pantalla",
    "Impressions per day per screen": "Playouts por día por pantalla",
    "Impressions": "Playouts",
    "Remaining spots": "Playouts restantes",
    "Remaining impressions": "Imp. restantes",
    "Impressions bought": "Impresiones",
    "Modify impressions": "Modificar impresiones",
    "Modify impressions warning": "Modificar este valor actualizará el valor de los <b>playouts</b> y la <b>inversión</b> del anuncio.",
    "Modify impressions warning_cpmi": "Modificar este valor actualizará la <b>inversión</b> del anuncio.",
    "Modify playouts": "Modificar playouts",
    "Modify playouts warning": "Modificar este valor actualizará el valor de las <b>impresiones</b> y la <b>inversión</b> del anuncio.",
    "Modify subsidized impressions": "Modificar impresiones bonificadas",
    "Modify subsidized impressions warning": "Modificar este valor actualizará el valor de los <b>playouts</b> y la <b>inversión</b> del anuncio. Además se verá afectado el <b>CPM efectivo</b>.",
    "Modify subsidized impressions warning_cpmi": "Modificar este valor actualizará la <b>inversión</b> del anuncio. Además se verá afectado el <b>CPM efectivo</b>.",
    "Modify subsidized playouts": "Modificar playouts bonificados",
    "Modify subsidized playouts warning": "Modificar este valor actualizará el valor de las <b>impresiones</b> y la <b>inversión</b> del anuncio. Además se verá afectado el <b>CPM efectivo</b>.",
    "Effective CPM": "CPM Efectivo",
    "Screen CPM": "CPM de pantalla",
    "Mobile": "Móvil",
    "Outdoor": "Exterior",
    "Indoor": "Interior",
    "Point of sale": "Punto de venta",
    "Region": "Región",
    "Format": "Formato",
    "Search by city, place, region...": "Buscar por ciudad, lugar, región...",
    "Big": "Grande",
    "Other Filters": "Otros Filtros",
    "Show and edit filters": "Ver y editar filtros",
    "circuit": "Circuito",

    // ScreenCardComponent
    "Real-time audience": "Audiencia en tiempo real",
    "Audience detail": "Detalle de audiencia",
    "Non-automated screen. Click to see detail": "Pantalla no automatizada. Click para ver detalles.",
    "Non-automated screen": "Pantalla no automatizada.",
    "The screens of this circuit are synchronized": "Las pantallas de este circuito están sincronizadas",
    "This screen does not have the real-time print notice. Therefore, print reports may take up to 48 hours to be reflected.": "Esta pantalla no cuenta con el aviso de playouts en tiempo real. Por lo que los reportes de playouts pueden demorar en verse reflejados, y pueden verse desfasados en el tiempo.",
    "Screen belonging to the circuit": "Pantalla perteneciente al circuito",
    "of count_secondary_displays screens": "de count_secondary_displays pantallas",
    "It is not possible to purchase these screens individually.": "No es posible comprar estas pantallas individualmente.",
    "sync": "sincronizado",
    "spots/day": "playouts / día",
    "spots subsidized/day": "playouts bonificados / día",
    "impressions/day": "imp. / día",
    "Audience Average": "Audiencia promedio",
    "Average audience of your screen": "Audiencia promedio de tu(s) pantalla(s)",
    "Audience by day of the week": "Audiencia promedio por días de la semana",
    "Audience by time of day": "Audiencia promedio por horas del día",
    "Monday": "Lunes",
    "Tuesday": "Martes",
    "Wednesday": "Miércoles",
    "Thursday": "Jueves",
    "Friday": "Viernes",
    "Saturday": "Sábado",
    "Sunday": "Domingo",
    "Average audience of your screen by day of the week": "Audiencia promedio de tu(s) pantalla(s) por día de la semana",
    "Average audience per hour in the day": "Audiencia promedio por hora en el día",
    "Select days of the week": "Seleccione días de la semana",
    "Filter audience by day of the week": "Filtrar audiencia por día de la semana",
    "Filter": "Filtrar",
    "Average audience by date": "Audiencia promedio por fecha",
    "Select hours of the day": "Seleccionar horas del día",
    "Filter audience by day of the week or hour": "Filtrar audiencia por día de la semana u hora",
    "Total number of people impacted": "Total de personas impactadas",
    "Day of greatest impact": "Día de mayor impacto",
    "Biggest Impact/Day": "Mayor Impacto / Día",
    "Hour with the greatest impact": "Horario con mayor impacto",
    "Biggest Impact/Hour": "Mayor Impacto / Hora",
    "Sum of Impressions per day (Dates)": "Suma de Impresiones por día (Fechas)",
    "Average Impressions per Hour (Dates)": "Promedio de Impresiones por Hora (Fechas)",
    "Comparison by Screen": "Comparación por Pantalla",
    "Sum of Impressions per day": "Suma de impresiones por día",

    // RequestSpecialCpmComponent - RequestSpecialPriceComponent
    "Agreed prices": "Precios acordados",
    "Send request": "Enviar solicitud",
    "You can request the agreed price to the media company by entering the agreed amount below. When you send it, the media company will receive an email with the request and LatinAd will notify you when the set price is reached to continue with your purchase.": "Podrá solicitar al Media Owner el precio acordado ingresando la cantidad acordada a continuación, al enviarlo, el Media Owner recibirá un mail con la solicitud y LatinAd le avisará cuando sea aceptada para continuar con su compra.",
    "You can request the agreed price to the media company by entering the agreed amount below. When you send it, the media company will receive an email with the request and the system will notify you when the set price is reached to continue with your purchase.": "Podrá solicitar al Media Owner el precio acordado ingresando la cantidad acordada a continuación, al enviarlo, el Media Owner recibirá un mail con la solicitud y el sistema le avisará cuando sea aceptada para continuar con su compra.",
    "The original price is": "El precio original es de",
    "per CPM.": "por CPM.",
    "per day.": "por día.",
    "Agreed price": "Precio acordado",
    "Final prices may contain platform commissions and may vary depending on the selected client": "Los precios finales pueden contener comisiones de plataformas y pueden variar dependiendo el cliente seleccionado",
    "Request agreed price": "Solicitar precio acordado",
    "The agreed price must be greater than 0": "El precio acordado debe ser mayor a 0",
    "The agreed price must be less than the original price": "El precio acordado debe ser menor al precio original",
    "There is already a cpm price arrangement request for this display": "Ya existe una solicitud de acuerdo de precio para esta pantalla",
    "There is already a cpm price arrangement for this display": "Ya existe un acuerdo de precio con esta pantalla",
    "There is already a price arrangement request for this display": "Ya existe una solicitud de acuerdo de precio para esta pantalla",
    "There is already a price arrangement for this display": "Ya existe un acuerdo de precio con esta pantalla",
    "Request sent successfully": "Solicitud enviada con éxito",
    "To keep in mind": "A tener en cuenta",
    "The agreed-upon price does not include local or international taxes.": "El precio acordado no incluye impuestos locales ni internacionales.",
    "Final prices may include platform fees and may vary depending on the selected client.": "Los precios finales pueden contener comisiones de plataformas y pueden variar dependiendo el cliente seleccionado.",
    "In the event that the screen price is in a different currency than the one being used for the purchase, final prices may vary due to conversion.": "En el caso en que el precio de la pantalla esté en una moneda diferente a la que se intenta comprar, en el precio final pueden presentarse variaciones por conversión.",
    "You already have an agreed price": "Ya tiene un precio acordado",

    // CardComponent
    "screens that you added to the selection have cameras measuring audience. You can go to the detail of each one to analyze the data and optimize your campaign": "pantallas que agregó a la selección tienen medición de audiencia. Puede ir al detalle de cada una para analizar los datos y optimizar su campaña",
    "Screens measuring audience": "Pantallas midiendo audiencia",
    "Estimated impressions based on campaign settings. You can add campaign days (in traditional) or increase the budget (in programmatic).": "Número de personas que verán su anuncio o grupo de anuncios según la configuración de la campaña. ",
    "Total screens added in the campaign": "Pantallas totales agregadas en la campaña",
    "See audience details": "Ver detalle de estimado de audiencia",
    "See audience button": "Ver",
    "Max. available imp.": "Imp. Máx. Disponibles",
    "Max. avail. imp.": "Imp. Máx. Disp.",
    "Max. available impressions": "Impresiones máximas disponibles",
    "audience impressions": "Impresiones",
    "Audience impressions": "Impresiones",
    "delivered spots": "Playouts",
    "estimated playouts qualifier": "estimados",
    "projected playouts qualifier": "proyectados",
    "minimum playouts qualifier": "mínimos",
    "playouts label": "Playouts {{qualifier}}",
    "playouts remaining label": "Playouts {{qualifier}} restantes",
    "subsidized playouts label": "Playouts bonificados {{qualifier}}",
    "playouts per day label": "playouts {{qualifier}} / día",
    "Upload material": "Subir anuncios",
    "Value based on screen occupancy statistics, so it can vary daily.": "Valor basado en las estadística de ocupación de la pantalla, por lo que puede variar diariamente.",
    "(CPM) cost per thousand impression": "Costo de impactar a mil personas, promediado y ponderado según la inversión en cada pantalla para toda la campaña",
    "(CPM) cost per thousand impression by group": "Costo de impactar a mil personas, promediado y ponderado según la inversión en cada pantalla para todo el grupo",
    "CPM Average": "CPM promedio",
    "Original CPM": "CPM original",
    "Final CPM": "CPM final",
    "Versions": "Versiones",
    "Selected ads": "Anuncios seleccionados",
    "Used ads": "Anuncios usados",
    "Estimated impressions based on campaign settings. You can add campaign days( in traditional) or increase the budget (in programmatic).": "Impresiones estimadas según la configuración de la campaña. Podés agregar días a la campaña (en tradicional) o aumentar el presupuesto (en programática).",
    "Ad state": "Estado del anuncio",
    "Ad information": "Información del anuncio",
    "On hold": "En espera",
    "This group includes ads with the following status. Expand the group to view them.": "Este grupo incluye anuncios con el siguiente estado. Desplegar el grupo para visualizarlos.",

    // CheckoutStepsComponent
    "Campaign budget": "Ppto. de campaña",
    "You can configure the impressions per screen and see how the updated budget varies according to the impact you want.": "Puede configurar los playouts por pantalla y ver como varía el presupuesto actualizado según el impacto que desee.",

    // StepsComponent
    "Select screens": "Seleccioná pantallas",
    "Upload your spots": "Subí tus anuncios",
    "Launch your campaign": "Lanzá tu campaña",

    //Contents of campaign
    "Required resolutions": "Resoluciones requeridas",
    "Required resolution": "Resolución requerida",
    "Tolerance": "Tolerancia",
    "Clear progress": "Limpiar progreso",
    "Clear all contents added to the campaign, clearing its progress": "Limpiar todo el anuncio agregado a la campaña, limpiando su progreso",
    "Info tolerance": "Al aumentar la tolerancia, permitirá que anuncios se muestren en pantallas que no coincidan con la resolución exacta (luego podrá optar por mostrar espacios en negro o estirar el anuncio).",
    "for the screen": "Para la pantalla",
    "for these versions": "para estas versiones",
    "for screens grouped as": "Para las pantallas agrupadas como",
    "To replace this content": "Para remplazar este anuncio",

    // VideoUploadComponent
    "the file is not ready yet": "el archivo todavía no esta listo",
    "upload a file for the campaign": "subir un archivo para la campaña",
    "Campaign successfully created": "Campaña creada con éxito",
    "Proposal successfully created": "Propuesta creada con éxito",
    "You can see it in the My campaigns section.": "Puede verla en la sección Mis campañas.",
    "You have not selected screens, you can go back to the map and do it from there.": "No ha seleccionado pantallas, puede volver al mapa y hacerlo desde ahí.",
    "Your campaign": "Tu campaña",
    "Your proposal": "Tu propuesta",
    "Contents library": "Sube y selecciona tus anuncios",
    "Content added in campaign list": "Anuncio agregado en la lista de campaña",
    "Added": "Agregado",
    "You must select a content": "Selecciona anuncios en la sección de arriba",
    "Aspect": "Aspecto",
    "General dimensions": "Dimensiones generales",
    "Type of screen": "Tipo de pantalla",
    "Ubication": "Ubicación",
    "Group by": "Agrupar por",
    "Output settings": "Ajustes de playouts",
    "Frequency settings": "Ajuste de frecuencia",
    "Organize screens": "Organizar pantallas",
    "Assign": "Asignar",
    "Confirm assign spots": "Confirmar asignar playouts",
    "Confirm assign playouts title": "Confirmar cambio de frecuencia",
    "Confirm assign playouts body": "Estás por asignar playouts {{qualifier}} en todos los creativos por igual, lo que modificará el presupuesto total y cualquier distribución previa de inversión e impresiones. ¿Deseas continuar?",
    "Balance spots": "Balancear playouts",
    "You're about to assign the spots across all screens, which will modify any previous spot distribution. Do you wish to continue?": "¿Estás a punto de asignar los playouts en todas las pantallas, lo que modificará cualquier distribución de playouts anterior. ¿Deseas continuar?",
    "Contents for the campaign": "Anuncios para la campaña",
    "Give your campaign a name so you can identify it": "Nombrá tu campaña para que puedas identificarla",
    "Selection card title": "¿Qué vas a hacer hoy?",

    "Create campaign step title": "Crear campaña",
    "Create campaign step description": "Planificá una campaña completa con anuncios, playouts y fechas de publicación.",
    "Create campaign step description_cpmi": "Planificá una campaña completa con anuncios, impresiones y fechas de publicación.",
    "Create proposal": "Crear propuesta",
    "Make a proposal step title": "Crear una propuesta",
    "Make a proposal step description": "Generá una propuesta con alcance y presupuesto para cotizar con un cliente.",

    "Add more information if you need it": "Agregá más información",
    "Campaign objective": "Objetivo de la campaña",
    "Objective": "Objetivo",
    "You reached the character limit!": "¡Alcanzaste el límite de caracteres!",
    "Campaign name": "Nombre de campaña",
    "Campaign extra information": "Información adicional de la campaña",
    "Briefly describe the purpose and goals of your campaign.": "Describe brevemente el propósito y objetivos de tu campaña.",
    "Is it a test campaign?": "¿Es campaña de prueba?",
    "Pause display": "Pausar pantalla",
    "You have already uploaded your ad! If you want to change it for all screens, click below": "¡Ya subiste tu anuncio!, si querés cambiarlo para todas las pantallas hacé click a continuación.",
    "Change spot material": "Cambiar anuncio",
    "general rule": "regla general",
    "General Rule (will apply to all screens)": "Regla General (se aplicará a todas las pantallas)",
    "Delete ad": "Limpiar anuncio",
    "Clear campaign progress in progress": "Limpiar progreso de campaña en proceso",
    "Yes, clean": "Si limpiar",
    "All the progress you have made so far in this campaign will be cleaned up, such as the campaign name, the ads for each screen, and the settings.": "Se limpiará todo el progreso que ha hecho hasta el momento en esta campaña, como el nombre de la campaña, los anuncios para cada pantalla y las configuraciones.",
    "Upload your ad": "Cargá tu anuncio",
    "Upload your ad (an image or a video), to preview how it will look on each of the screens you chose.": "Subí tu anuncio (una imagen o un video), para previsualizar como quedará en cada una de las pantallas que elegiste.",
    "Drag the ad here or": "Arrastrá el anuncio acá o",
    "click to load it.": "hacé click para cargarlo.",
    "Dont have the ad?": "¿No tenés el anuncio?",
    "Contact us and we will advise you.": "Contactanos y te asesoramos.",
    "Url whatsapp, Contact us": "https://api.whatsapp.com/send?phone=5492615019508&text=Hola,%20me%20gustaría%20hacer%20una%20publicidad%20pero%20todavía%20no%20tengo%20la%20pieza%20gráfica.%20",
    "The time indicated by each screen will be displayed.": "Se exhibirá el tiempo que indica cada pantalla.",
    "You can change the ad for each of the selected screens. Keep in mind that if it is an image, the ad will display the space time indicated by each screen. For videos, it will be the time of the video.": "Podés cambiar el anuncio para cada una de las pantallas seleccionadas. Tené en cuenta que si es una imagen, el anuncio se exhibirá el tiempo del espacio que indica cada pantalla. Para los videos, será el tiempo del video.",
    "Selected screens": "Pantallas seleccionadas",
    "Updated budget": "Presupuesto actualizado",
    "Tight budget": "Presupuesto ajustado",
    "Balance $": "Balancear $",
    "Redistribute": "Redistribuir",
    "Total spots": "Playouts proyectados",
    "You can configure the spots per screen and see how the adjusted budget varies depending on the impact you want.": "Puede configurar los playouts por pantalla y ver como varía el presupuesto ajustado según el impacto que desee.",
    "You can configure the spots per screen and see how the adjusted budget varies depending on the impact you want._cpmi": "Puede configurar las impresiones por pantalla y ver como varía el presupuesto ajustado según el impacto que desee.",
    "Upload your main ad to see how it will look on each screen": "Suba su anuncio principal para ver como se verá en cada pantalla",
    "Your video of": "Tu video de",
    "secs exceeds the playing time accepted by some selected screens. You can change the ad for a shorter one, or you can leave it and pay the proportional value for the time exceeded.": "segs excede el tiempo de reproducción aceptado por algunas pantallas seleccioandas.Podés cambiar el anuncio por uno de menor tiempo, o podés dejarlo y pagar el valor proporcional por el tiempo excedido.",
    "secs exceeds the standard time for programmatic campaigns of 10 seconds. You can change the ad for a shorter time.": "segs excede el tiempo estándar de las campañas programáticas de 10 segundos. Podés cambiar el anuncio por uno de menor tiempo.",
    "Your ad is": "Tu anuncio es",
    "an image": "una imagen",
    "a video": "un video",
    "Printed so far": "Exhibido hasta ahora",
    "It has a duration of": "Tiene una duración de",
    "secs, and this time will be displayed": "segs, y se exhibirá este tiempo",
    "Campaign successfully edited": "Campaña editada con éxito",
    "You can review it from this section before generating a payment.": "Puede revisarla desde esta sección antes de generar un pago.",
    "You can exit edit mode to create a new campaign.": "Puede salir del modo editar, para crear una campaña nueva.",
    "You are in campaign edit mode": "Está en modo editar campaña",
    "Exit": "Salir",
    "Go back to the original budget and recalculate impressions (changes you have made in impressions for each Spot will be erased)": "Volver al presupuesto original y recalcular playouts (se borrarán cambios que haya hecho en playouts por cada anuncio)",
    "Go back to the original budget (n_amountBudget) and recalculate impressions (changes you have made in impressions for each Spot will be erased)": "Volver al presupuesto original (n_amountBudget) y recalcular playouts (se borrarán cambios que haya hecho en playouts por cada anuncio)",
    "Redistribute the new budget and recalculate spots (changes made to spots for each ad will be deleted)": "Redistribuir el nuevo presupuesto y recalcular playouts (se borrarán cambios que haya hecho en playouts por cada anuncio)",
    "For each screen it will equalize the investment and recalculate the spots (changes you have made to spots for each ad or screen will be erased)": "Por cada pantalla igualará la inversión y recalculará los playouts (se borrarán cambios que haya hecho en playouts por cada anuncio o pantalla)",
    "For each screen it will equalize the investment and recalculate the spots (changes you have made to spots for each ad or screen will be erased)_cpmi": "Por cada pantalla igualará la inversión y recalculará las impresiones (se borrarán cambios que haya hecho en impresiones por cada anuncio o pantalla)",
    "The initial amount was modified; you can redistribute the budget": "El monto inicial fue modificado, puedes redistribuir el presupuesto.",
    "Increase prints to fill all remaining": "Aumentar los playouts para ocupar todos los restantes",
    "Design and change spot": "Diseñar y cambiar anuncio",
    "Design spot": "Diseñar anuncio",
    "What resolution will your main Spot have?": "De que resolución será tu anuncio principal?",
    "Width (px)": "Ancho (px)",
    "Height (px)": "Alto (px)",
    "You will need to create an account and log in the first time you want to create a design.": "Deberá crear una cuenta e inciar sesión la primera vez que quiera crear un diseño.",
    "Identify your ad...": "Identificá tu anuncio...",
    "Contents": "Contenidos",
    "Configuration": "Configuración",
    "Make payment": "Realizar pago",
    "View contents from the folder": "Carpeta de anuncios",
    "Upload": "Selecciona",
    "Upload continue": "o arrastra",
    "Upload continue 2": "anuncios aquí",
    "Upload message 1": "Selecciona una",
    "Upload message 2": "carpeta para",
    "Upload message 3": "subir anuncios",
    "Folder advertisement": "Una carpeta es un contenedor de anuncios agrupados por marcas. Para crear nuevas carpetas debe crear nuevas marcas dentro de clientes en el cms. Haz clic en el <icon/> para aprender como hacerlo.",
    "Version explain": "Antes de seleccionar anuncios para su campaña, puede categorizarlos por la versión que corresponda. Por ejemplo: Versión 1 = Desayuno, Versión 2 = Media tarde. Haz clic en el <icon/> para aprender como hacerlo.",
    "Select a folder": "Seleccinar una carpeta",
    "This folder is not modified": "This folder is not modified",
    "There are ads that do not adapt correctly to the resolutions. You can continue or select ads from closer resolutions.": "Hay anuncios que no se adecuan correctamente a las resoluciones. Puede continuar o seleccionar anuncios de resoluciones más cercanas.",
    "Content information": "Información del anuncio",

    //ContentsLibraryComponent
    "Library of contents": "Librería de anuncios",
    "Choose the version before choosing content": "Seleccionar una versión antes de elegir contenido",
    "Remove ad from the library": "Eliminar anuncio de la librería",
    "Copy the name of this ad to all ads in the same version.": "Copia el nombre de este anuncio en todos los anuncios de la misma versión.",
    "You are about to clone this ad name to all other ads in the same version. This action will overwrite the current names.": "Estás a punto de clonar el nombre de este anuncio en todos los demás anuncios de la misma versión. Esta acción sobrescribirá los nombres actuales",
    "Add content to the campaign": "Agregar anuncio a la campaña",
    "This ad does not fit the screen resolution according to the tolerance set in the campaign": "Este anuncio no se ajusta a la resolución de la pantalla según la tolerancia establecida en la campaña",
    "Remove ads from the campaign": "Quitar anuncios de la campaña",
    "Stop using this ad for the campaign.": "Dejar de usar este anuncio para la campaña.",
    "Apply ad to available resolutions": "Aplicar anuncio a resoluciones disponibles",
    "Remove relation between content and displays": "Quitar relación entre contenido y pantallas",
    "Unlink ad from this screen group.": "Desvincular anuncio a este grupo de pantallas.",
    "It's the last relation on a screen, to delete it, its contents should be reorganized": "Es la ultima relación de una pantalla, para eliminarla deberia reorganizar sus contenidos",
    "This version cannot be deleted: at least one screen would be left without any ad.": "No se puede eliminar esta versión: al menos una pantalla quedaría sin ningún anuncio.",
    "It's the last ad on screen {{screenName}}; to delete it, first add another ad there": "Es el último anuncio de la pantalla {{screenName}}; para eliminarlo, primero agregá otro anuncio ahí",
    "Are you sure you want to remove this content from the campaign": "¿Estás seguro de que desea quitar este contenido de la campaña?",
    "version": "Versión",
    "Version of the ad": "Versión del anuncio",
    "Remplace": "Reemplazar",
    "Remplace version": "Reemplazar versión",
    "Apply rule by versions": "Aplicar regla por versiones",
    "Create another version": "Crear otra versión",
    "A version with that resolution already exists, you want to replace the content": "Ya existe una versión con esa resolución, deseas reemplazar el anuncio",
    "A version with that resolution already exists on another screen, a new version will be created to avoid replacing the one currently in use.": "Ya existe una versión con esa resolución en otra pantalla. Se creará una nueva versión para evitar reemplazar la que está en uso.",
    "Select a folde": "Seleccionar una carpeta",
    "Displays added in this relation": "Pantallas agregadas en esta relación",
    "Hours": "Horas",
    "my_content": "Mis anuncios",
    "default": "Por defecto",

    "REQUIRED": "REQUERIDA",
    "Inactive version": "Inactiva",
    "This version has ads that do not match any screen; they will not be saved.": "Esta versión tiene anuncios que no coinciden con ninguna pantalla; no se van a guardar.",
    "This ad does not match any screen and will not be saved": "Este anuncio no coincide con ninguna pantalla y no se va a guardar",
    "There are ads that do not match any screen and will not be saved ({{versions}}). Continue?": "Hay anuncios que no coinciden con ninguna pantalla y no se van a guardar ({{versions}}). ¿Continuar?",
    "This version will be deactivated. Its remaining outputs will be redistributed equitably among the other active versions; outputs already delivered are preserved.": "Esta versión se va a desactivar. Sus salidas restantes se van a repartir equitativamente entre las otras versiones activas; las salidas ya entregadas se conservan.",
    "Version deactivated. Its remaining outputs were redistributed among the other active versions.": "Versión desactivada. Sus salidas restantes se repartieron entre las otras versiones activas.",
    "Ad successfully updated.": "Anuncio actualizado con éxito.",
    "A version with that name already exists.": "Ya existe una versión con ese nombre.",
    "Names like V1, V2... are reserved for automatic versions and can't be used to rename.": "Nombres como V1, V2... están reservados para versiones automáticas y no se pueden usar para renombrar.",
    "This version is inactive; its remaining outputs were redistributed.": "Esta versión está inactiva; sus salidas restantes ya fueron repartidas.",
    "Ads in {{version}}": "Anuncios en {{version}}",
    "Version name": "Nombre de la versión",
    "Ads for the campaign": "Anuncios para la campaña",
    "Create general rule": "Crear regla general",
    "Pending resolutions": "Pendientes",
    "Covered resolutions": "Asignadas",
    "Search resolution": "Buscar resolución",
    "Unassigned": "Sin asignar",
    "Go to {{version}}": "Ir a {{version}}",
    "Display": "Display",
    "total screens": "pantallas totales",
    "pending resolutions": "pendientes",
    "All assigned": "Todo asignado",
    "Add to version": "Agregar a la versión",
    "Drag to add to version": "Arrastrá para agregar a la versión",
    "Drag the ads you want to add to the campaign here, or add them from the ads list": "Arrastrá acá los anuncios que quieras agregar a la campaña o agregalos desde la lista de anuncios",
    "Rename version": "Renombrar versión",
    "Delete version": "Eliminar versión",
    "Add version": "Agregar versión",
    "Date": "Fecha",
    "Folder management is available in the Ad Library.": "La gestión de carpetas está disponible en la Librería de anuncios.",
    "This ad will be unlinked from the group of screens for this resolution.": "Este anuncio se desvinculará del grupo de pantallas para esta resolución.",
    "Unlink this ad from these screens": "Desvincular este anuncio de estas pantallas",
    "Unlinked: {{name}}": "Desvinculado: {{name}}",
    "This ad was unlinked from these screens": "Este anuncio fue desvinculado de estas pantallas",
    "Relink this ad to these screens": "Volver a vincular este anuncio a estas pantallas",
    "Not available": "No disponible",

    // ModalContent
    "Content data": "Datos de anuncio",
    "Tolerance applied": "Tolerancia aplicada",
    "General information": "Información general",
    "Edit name": "Editar nombre",
    "Preparing your proposal...": "Preparando tu propuesta...",
    "Tolerance set for this campaign; adjust it from the Ad library step": "Tolerancia configurada para esta campaña; se ajusta desde el paso Librería de anuncios",
    "Are you sure you want to delete this spot?": "¿Está seguro de que desea dejar de usar este anuncio en la campaña? Puedes agregarlo nuevamente después.",
    "Are you sure you want to delete all progress so far? It will remove the loaded ads and created relationships.": "¿Estás seguro de que quieres eliminar todo el progreso hasta ahora? Eliminara los anuncios cargados y las relaciones creadas.",
    "Delete": "Eliminar",

    //Modal Edit Campaign Manager
    "Some ads do not match the screen resolutions": "Algunos anuncios no coinciden con las resoluciones de pantalla",
    "in this group": "en este grupo",
    "on this display": "para esta pantalla",
    "The campaign allows a tolerance of": "La campaña permite una tolerancia de",
    "%. If you want to increase it, you can adjust it from the previous step, in the Ads section.": "%. Si desea aumentarla, puede ajustarla desde el paso anterior, en la sección Anuncios.",
    "This ad doesn't match any of the resolutions. Increase the campaign tolerance in the previous step and try again.": "Este anuncio no coincide con ninguna de las resoluciones. Aumente la tolerancia de la campaña en el paso anterior y vuelva a intentarlo.",
    "Version already exists for this resolution": "Versión ya existente para esta resolución",
    "Does not match any resolution, increase tolerance in the previous step.": "No coincide con ninguna resolución, aumente la tolerancia en el paso anterior.",
    "Increase the campaign tolerance in the Ads section.": "Aumente la tolerancia de la campaña en la sección Anuncios.",
    "resolution.mismatch.single": "Algunos anuncios no coinciden con la resolución de esta pantalla. La campaña permite una tolerancia del {{tolerance}}%. Si deseas aumentarla, puedes ajustarla desde el paso anterior, en la sección Anuncios.",
    "resolution.mismatch.group": "Algunos anuncios no coinciden con las resoluciones de este grupo. La campaña permite una tolerancia del {{tolerance}}%. Si deseas aumentarla, puedes ajustarla desde el paso anterior, en la sección Anuncios.",

    //Under Minimum Spots Modal
    "Some screens do not meet the minimum investment": "Algunas pantallas no cumplen con la inversión mínima",
    "Some screens do not meet the minimum daily investment": "Algunas pantallas no cumplen con la inversión mínima diaria",
    "Minimum investment": "Inversión mínima",
    "Minimum investment/day": "Inversión mínima/día",
    "Equivalent spots": "Playouts equivalentes",
    "Equivalent impressions": "Impresiones equivalentes",
    "These screens will be rejected if the minimum investment is not increased": "Estas pantallas serán rechazadas si no se aumenta la inversión mínima",
    "These screens will be rejected if the minimum daily investment is not increased": "Estas pantallas serán rechazadas si no se aumenta la inversión mínima diaria",
    "Adjust investment now": "Ajustar inversión ahora",
    "Ignore and continue": "Ignorar y continuar",
    "Current": "Actual",
    "Need": "Necesitás",
    "more": "más",

    //CardGeneralComponent
    "Total price": "Precio total",

    // ScreenPreview
    "Add a Spot for this screen. (In case they meet the same rules, it will print once each)": "Agregar un anuncio para esta pantalla. (En caso de que cumplan las mismas reglas, imprimirá una vez cada uno)",
    "In programmatic the ads should not exceed the maximum time of the advertising space on the screen, otherwise they could be cut off in this time": "En programática los anuncios no deben superar el tiempo máximo del espacio publicitario de la pantalla, caso contrario podrían verse cortados en este tiempo",
    "Exceeded in": "Excedido en",
    "secs": "segs",
    "If you do not change the ad for a shorter one, it will add approximately": "Si no cambia el anuncio por uno más corto, se sumará aproximadamente",
    "per day for this screen.": "por día por esta pantalla.",
    "Expand ad": "Ajustar tamaño del anuncio a la resolución de la pantalla",
    "Stretch ad/s on group screens. This can distort the ads.": "Estirar anuncio/s en las pantallas del grupo. Esto puede deformar los anuncios.",
    "Do not stretch ad/s on the screens. Black spaces can be seen.": "No estirar anuncio/s en las pantallas. Pueden verse espacios en negro.",
    "Stretch ad/s until they occupy 100% of the screen. This may distort the advertisement.": "Estirar anuncio/s hasta ocupar el 100% de la pantalla. Esto puede deformar el anuncio.",
    "Do not stretch ad/s on the screen. Black spaces can be seen.": "No estirar anuncio/s en la pantalla. Pueden verse espacios en negro.",
    "Do not stretch the ad on the screen. Black spaces can be seen.": "No estirar el anuncio en la pantalla. Pueden verse espacios en negro.",
    "Time of each space on this screen. An extra fee may be charged if the advertisement exceeds this time.": "Tiempo de cada espacio de esta pantalla. Podría cobrarse un extra en el caso que el anuncio supere este tiempo.",
    "By enabling this option, the ad is subsidized, affecting the price of the campaign.": "Habilitando esta opción el anuncio queda bonificado, afectando el precio de la campaña",
    "Return original resolution": "Volver resolución original",
    "Ad created in canva, you can edit and change it for this screen or relationship.": "Anuncio creado en canva, puede editarlo y cambiarlo para esta pantalla o relación.",
    "Create new ad in canva for this relationship": "Crear anuncio nuevo en canva para esta relación",
    "Change material": "Cambiar anuncio",
    "Change ad for this": "Cambiar anuncio para esta",
    "Change ad for this screens": "Cambiar anuncio para estas pantallas",
    "relationship": "relación",
    "Remove spot": "Quitar anuncio",
    "Screen detail": "Detalle de pantalla",
    "Remove screen": "Quitar pantalla",
    "Remove screen from campaign": "Quitar pantalla de campaña",
    "Add another rule": "Agregar otra regla",
    "Add rule": "Agregar regla",
    "Remove rules": "Quitar reglas",
    "Clone rules": "Clonar reglas",
    "Standard time of the programmatic space, an extra could be charged in the case of a longer ad.": "Tiempo estándar del espacio programático, podría cobrarse un extra en el caso de ser un anuncio de mayor tiempo.",
    "Screen space time": "Tiempo del espacio de la pantalla",
    "Space time": "Tpo del espacio",
    "Standard time of the space of this screen, an extra could be charged in the case of being a longer ad.": "Tiempo estándar del espacio de esta pantalla, podría cobrarse un extra en el caso de ser un anuncio de mayor tiempo.",
    "Potential reach in real time of the screen based on the measurement data with cameras, together with the dates and rules selected. Remember to optimize your campaign based on audience data. Also remember that the greater the number of spots, the greater impression you can achieve.": "Alcance potencial en tiempo real de la pantalla en base a los datos de audiencia, junto a las fechas y reglas seleccionadas. Recuerda optimizar tu campaña en base a los datos de audiencia. También recuerda que a mayor cantidad de playouts, mayor impacto puede lograr.",
    "Real-time screen impressions, shows the number of people who will see your spot or group of spots based on camera measurement data, along with dates, selected rules, and investment made. Remember that the greater the investment, the greater the impact it will generate.": "Impresiones en tiempo real de la pantalla, muestra la cantidad de personas que verán su anuncio o grupo de anuncios en base a los datos de audiencia, junto a las fechas, reglas seleccionadas e inversión realizada. Recuerde que a mayor inversión mayor impacto generará",
    "Audience data provided by the media. They are impression based on third-party measurement data. Remember to optimize your campaign based on audience data. Also remember that the more spots, the more impression you can achieve.": "Datos de audiencia brindada por el Media Owner. Basados en datos de medición de terceros. Recuerde optimizar su campaña en base a los datos de audiencia. Tenga presente que a más playouts, mayor impacto puede lograr.",
    "See screen detail to see the days and hours of operation, to optimize your rules": "Ver detalle de pantalla para ver los días y horarios de funcionamiento, para optimizar sus reglas",
    "Subsidize price of this screen": "Bonificar precio de esta pantalla",
    "Subsidize price": "Bonificar precio",
    "First load content for subsidize the campaign": "Primero cargar contenido para bonificar la campaña",
    "By enabling this option, the screen is subsidize, affecting the price of the campaign": "Habilitando esta opción el anuncio queda bonificado, afectando el precio de la campaña.",
    "By enabling this option, the spot is subsidize, affecting the price of the campaign": "Habilitando esta opción el anuncio queda bonificado, afectando el precio de la campaña",
    "By enabling this option, the campaign is subsidize, your price will be zero": "Habilitando esta opción la campaña queda bonificada, su precio va ser cero",
    "Avoid getting your ad disapproved, add %deference_cpm impressions to cover the CPM!": "¡Evitá que rechacen tu anuncio, agregá %deference_cpm playouts para cubrir el CPM!",
    "Congratulations! You reached the minimum CPM.": "¡Felicitaciones! Llegaste al CPM minimo.",
    "Congratulations! You exceeded the minimum CPM.": "¡Felicitaciones! Pasaste el CPM.",
    "To delete need at least two screens in the campaign": "Para eliminar se necesitan al menos dos pantallas en la campaña",
    "Setting this value in all screen and spot": "Establecer este valor en todas las pantallas y anuncios",
    "Add contents on the screen": "Agregar anuncios en la pantalla",
    "Add contents to screen group": "Agregar anuncios al grupo de pantallas",
    "Set up rules in group of displays": "Configurar reglas en grupo de pantallas",
    "Set up rules in campaign": "Configurar reglas en campaña",
    "Rules in group of displays": "Reglas en grupo de pantallas",
    "Rules in display": "Reglas en pantalla",
    "You must select at least one version": "Debe seleccionar al menos una versión",
    "Clone spot": "Clonar anuncio",
    "Rules tooltip": "Crea y aplica reglas. Haz clic en el <icon/> para aprender como hacerlo.",
    "I don’t have my ads": "No tengo mis anuncios",
    "I don’t have my ads tooltip": "Si no tiene los anuncios para su campaña, haga clic en el <icon/> para aprender como proceder sin ellos.",

    // PaymentComponent
    "Error applying coupon": "Error al aplicar cupón",
    "The coupon has already been applied": "El cupón ya fue aplicado",
    "Coupon does not exist": "El cupón no existe",
    "A coupon has already been applied in this campaign": "Ya se aplicó un cupón en esta campaña",
    "An error occurred while applying coupon": "Ocurrió un error al aplicar cupón",
    "Coupon applied successfully": "Cupón aplicado con éxito",
    "Failed to delete coupon": "Error al eliminar cupón",
    "Coupon removed successfully": "Cupón eliminado con éxito",
    "The campaign has already been paid.": "La campaña ya ha sido pagada.",
    "Congratulations! Your payment has been credited.": "¡Felicitaciones! Su pago ha sido acreditado.",
    "You must select a country": "Debe seleccionar algún país",
    "The month / year": "El mes / año",
    "Its not valid": "no es válido",
    "Campaign payment": "Pago de campaña",
    "NAME LAST NAME": "NOMBRE APELLIDO",
    "Pay by credit / debit card": "Pagar con tarjeta de crédito / débito",
    "Pay with other means of payment": "Pagar con otros medios de pago",
    "Pay with Mercado Pago": "Pagar con Mercado Pago",
    "Information for direct cash payments with": "Información para pagos en efectivo directo con",
    "Please complete the form with your billing information and your contact telephone number, a n_label collector will contact you to coordinate the collection.": "Por favor completa el formulario con los datos de facturación y tu teléfono de contacto, un cobrador de n_label te contactará para coordinar el cobro.",
    "Please complete the form with your billing information and your contact telephone number, a Duoprint collector will contact you to coordinate the collection.": "Por favor completa el formulario con los datos de facturación y tu teléfono de contacto, un cobrador de Duoprint te contactará para coordinar el cobro.",
    "Telephone contact": "Teléfono de contacto",
    "Bank data": "Datos bancarios",
    "Card number": "Número de Tarjeta",
    "Please make a transfer to the following account, and put the number as a reference": "Por favor realiza una transferencia a la siguiente cuenta, y coloca como referencia el número",
    "Information for direct current account payments with": "Información para pagos en cuenta corriente directo con",
    "Once the payment has been made using this method, your media manager will be able to approve the campaign.": "Una vez realizado el pago con este método, su director de medios podrá aprobar la campaña.",
    "Billing Country": "País de Facturación",
    "export": "exportación",
    "Fill in the following information": "Complete los siguientes datos para su factura",
    "Address": "Dirección",
    "Street": "Calle",
    "Social name": "Nombre / Razón social",
    "Number": "Número",
    "Province": "Provincia",
    "Location": "Localidad",
    "Make a comment": "Realizar comentario",
    "Add here any comments you consider relevant to your campaign": "Agrega aquí cualquier comentario que consideres relevante para tu campaña",
    "Comment": "Comentario",
    "Edit comment": "Editar comentario",
    "Billing to client": "Factura a cliente",
    "Billing to agency": "Factura a agencia",
    "Last billing": "Última factura",
    "Additional Information": "Información adicional",
    "Security code": "Código de Seguridad",
    "Billing": "Facturación",
    "Postal code": "Código postal",
    "Generate ODC": "Generar ODC",
    "Created ODC": "ODC creado",
    "Ups, problem for create ODC": "Ups, problema para crear ODC",
    "Creating ODC": "Creando ODC",
    "Try our new version": "Prueba nuestra nueva versión",
    "Date expiry": "Fecha de vencimiento",
    "Document type": "Tipo de documento",
    "Document number": "Número de documento",
    "Name as it appears on the card": "Nombre como aparece en la tarjeta",

    // ODC modal
    "Purchase orders": "Órdenes de compra",
    "Date creation": "Fecha de creación",
    "Files": "Archivos",
    "There are no purchase orders uploaded": "No hay ordenes de compra cargadas",
    "view": "Ver",
    "ODC": "ODC",

    // PaymentTopbar
    "Go to map": "Ir al mapa",

    // ScreenComponent
    "South": "Sur",
    "North": "Norte",
    "West": "Oeste",
    "East": "Este",
    "Northeast": "Noreste",
    "Northwest": "Noroeste",
    "Southeastern": "Sureste",
    "Southwest": "Suroeste",
    "Class": "Clase",
    "Middle": "Media",
    "High": "Alta",
    "Lower": "Baja",
    "Mon": "Lun",
    "Tue": "Mar",
    "Wed": "Mie",
    "Thu": "Jue",
    "Fri": "Vie",
    "Sat": "Sab",
    "Sun": "Dom",
    "Off": "Apagada",
    "Remove from selection": "Quitar",
    "Add to selection": "Agregar",
    "Go to buy": "Ir a comprar",
    "Description": "Descripción",
    "Information": "Información",
    "Resolution": "Resolución",
    "Ads time": "Tiempo de anuncios",
    "Length of ads time": "Duración de los anuncios",
    "It is an approximate value, because is upload by screen owner.": "Este valor es aproximado, es cargado por el Media Owner.",
    "There is no audience measurement configured": "No tiene configurado la medición de audiencia",
    "Ad Duration": "Duración de anuncio",
    "Approximate impressions": "Playouts aproximados",
    "Cost": "Costo",
    "Daily": "Diaria",
    "Weekly": "Semanal",
    "Monthly": "Mensual",
    "No restrictions": "Sin restricciones",
    "Hide": "Ocultar",
    "Show": "Mostrar",
    "Approx impr": "Playouts aprox.",
    "It is an approximate value, because it depends on the days and rules you choose in your campaign. Once the campaign is created, you will get the exact impressions.": "Es un valor aproximado, por que depende de los días y reglas que elija en su campaña. Una vez creada la campaña, obtendrá los playouts exactos.",
    "Hours of Operation": "Hr. de funcionamiento",
    "Lit all day every day": "Encendida todo el día todos los días",
    "Allowed ad format": "Formato permitido",
    "Ad rotated": "Anuncio girado",
    "to the right": "a la derecha",
    "to the left": "a la izquierda",
    "Quality": "Calidad",
    "Orientation": "Orientación",
    "Floor elevation": "Elevación del suelo",
    "meters": "metros",
    "Viewing distance": "Distancia de visualización",
    "Target": "Target",
    "Restrictions": "Restricciones",
    "Conditions": "Condiciones",
    "Admit any ad or spot that respects everyday rules": "Admite cualquier anuncio que respete las normas cotidianas",
    "Live cameras": "Cámaras en vivo",
    "Today's traffic": "Tráfico de hoy",
    "Live camera not available": "Cámara en vivo no disponible",
    "Traffic": "Tráfico",
    "You have not configured a camera to measure the audience": "No ha configurado cámara para medir la audiencia",
    "Show original": "Mostrar original",
    "Translate to": "Traducir a",
    "List of days": "Lista de días",
    "Details": "Detalles",
    "Daily audience": "Audiencia diaria",
    "Weekly audience": "Audiencia semanal",
    "Monthly audience": "Audiencia mensual",
    "Map": "Mapa",
    "Table": "Tabla",
    "Multiple screens": "Múltiples pantallas",
    "Without restrictions": "Sin restricciones",
    "Cost per day": "Costo por día",
    "CPM impressions": "CPM impresiones",
    "CPM spots": "CPM playouts",
    "Cost per thousand impressions": "Costo por mil impresiones",
    "Cost per thousand spot": "Costo por mil playouts",
    "Cost per thousand impacts": "Costo por mil impresiones",

    // OnboardingComponent
    "Interest targeting": "Segmentación por interés",
    "Automobiles": "Automóviles",
    "Business": "Negocios",
    "Banking": "Banca",
    "Transport": "Transporte",
    "Government": "Gobierno",
    "Hospitality": "Hotelería",
    "Food": "Comida",
    "Health & Beauty": "Salud y belleza",
    "Temperature": "Temperatura",
    "Humidity": "Humedad",
    "Estimated audience for this location": "Audiencia estimada de esta localización",
    "Average per print": "Promedio por playout",
    "Estimated traffic": "Tráfico estimado",
    "Active screens": "Pantallas activas",
    "Estimated audience": "Audiencia",
    "Screens with cameras measuring traffic and people": "Pantallas con cámaras midiendo tráfico y personas",

    // Map
    "Remember to zoom out the map to see more results": "Recordá alejar el mapa para ver más resultados",
    "Only screens that are within the visible area of the map will be displayed.": "Solo se mostrarán pantallas que se encuentren dentro del área visible del mapa.",
    "If the screen is at its maximum capacity, at least your ad will be displayed": "Si la pantalla se encuentra con su capacidad máxima, como mínimo tu anuncio se exhibirá",
    "times per hour. Otherwise it will display more": "veces por hora. De lo contrario se exhibirá más",
    "Recommended duration": "Duración recomendada",
    "An extra may be charged in the event that your ad times out on some screens": "Podría cobrarse un extra en el caso que su anuncio exceda el tiempo en algunas pantallas",
    "Location, street or city": "Lugar, calle o ciudad",
    "Search on move": "Buscar al mover",
    "Programmatic advanced filters": "Filtros avanzados programática",
    "Getting results": "Obteniendo resultados",
    "Multiple faces screen": "Múltiples caras",
    "sides": "caras",
    "Circuit of n_screen screens": "Circuito de n_screen pantallas",
    "Selection filters": "Filtros de selección",
    "Results are filtered by country. You can": "Los resultados están filtrados por país. Puedes",
    "remove that filter and try again.": "eliminarlo y volver a intentar.",
    "Map filters": "Filtros en mapa",
    "Search by place": "Buscar por lugar",
    "Refinate your search": "Refina tu búsqueda",
    "Add screens by ID": "Agregar pantallas por ID",
    "Screen IDs to add": "IDs de pantallas a agregar",
    "Screen IDs placeholder": "Ingrese los IDs de las pantallas que desea agregar, puede pegar una lista separada por espacios, comas, puntos, punto y coma, o copiar una lista desde Excel",
    "Total screens": "Total de pantallas",
    "screens added to cart": "{{count}} pantalla(s) agregada(s) al carrito",
    "screens already in cart": "{{count}} pantalla(s) ya estaban en el carrito",
    "screens added summary": "{{count}} pantallas agregadas",
    "screens rejected summary": "{{count}} pantallas no pudieron agregarse",
    "Already added to campaign": "La pantalla ya fue agregada previamente a esta campaña",
    "ID not found": "ID no encontrado",
    "Screen archived": "Pantalla archivada",
    "Secondary screen": "Pantalla secundaria",
    "Screen not for sale": "Pantalla no disponible para la venta",
    "Campaign time too short": "Duración mínima de campaña no cumplida",
    "Not available for programmatic": "No disponible para campaña programática",

    // ScreenTypePreviewComponent
    "screens with": "pantallas con",
    "mixed content": "contenido mixto",
    "Exceeded on some screen": "Excedido en alguna pantalla",
    "of": " de ",
    "The spot will be seen n_days days, with n_impressions impressions per days": "El anuncio se verá n_days días, con n_impressions playouts por día",
    "Unable to distribute due to lack of remaining prints": "Imposible repartir por falta de playouts restantes",
    "Remaining to consume": "Restantes a consumir",
    "Impressions details": "Detalle de playouts",
    "Consumed": "Consumidas",
    "To consumed": "A consumir",
    "Total material": "Total anuncio",
    "Total display": "Total pantalla",
    "Investment detail": "Detalle de anuncio",
    "Remaining": "Restantes",
    "Total on display": "Total en pantalla",
    "Total on version": "Total en versión",
    "Total material subsidized": "Total anuncios bonificados",
    "day": "día",
    "days": "días",
    "You must select at least one day": "Debe seleccionar al menos un dia",

    // Displays
    "Square": "Cuadrada",
    "Vertical": "Vertical",
    "Horizontal": "Horizontal",
    "Super horizontal": "Super horizontal",
    "The email entered already exists": "El email ingresado ya existe",
    "Enter a valid email": "Ingrese un email válido",
    "The name must be less than 255 characters.": "El nombre debe ser menor a 255 carácteres.",
    "The last name must be less than 255 characters.": "El apellido debe ser menor a 255 carácteres.",
    "The company name already exists. Please enter another.": "El nombre de la empresa ya existe. Ingrese otro.",
    "Incorrect username or password": "Usuario o contraseña incorrectos",
    "Fill in all fields": "Complete todos los campos",
    "We cant find that email in our database, try another one.": "No encontramos ese mail en nuestra base, pruebe con otro.",
    "Incorrect security code": "Codigo de seguridad incorrecto",
    "The code must have 6 digits": "El código debe tener 6 dígitos",
    "Your account is not verified": "Tu cuenta no está verificada",
    "This account has already been verified.": "Esta cuenta ya fue verificada",
    "Unexpected error": "Error inesperado",
    "Too many attempts": "Ha realizado demasiadas solicitudes. Intente nuevamente más tarde.",
    "Account is not activated": "Esta cuenta no está activada",
    "Password changed": "Contraseña cambiada, por favor ingrese nuevamente",

    // Common
    "Good!": "Bien!",
    "Changes successfully saved": "Cambios guardados correctamente",
    "Loading": "Cargando",
    "Go back": "Volver",
    "Edit": "Editar",
    "Close": "Cerrar",
    "continue": "continuar",
    "edit": "editar",
    "Create": "Crear",
    "An error occurred, please try again": "Ocurrió un error, intente de nuevo",
    "Token expired, please login again": "Token vencido, vuelva a iniciar sesión",
    "Reload": "Volver a cargar",
    "Cancel": "Cancelar",
    "Contact us": "Contactanos",
    "Remove": "Quitar",
    "Add": "Agregar",
    "Can not be blank": "No puede estar en blanco.",
    "Categories": "Categorías",
    "Select a category": "Selecciona una categoría",
    "You must select a category": "Debe seleccionar una categoría",
    "You must select a option": "Debe seleccionar una opción",
    "All screens must have at least some content": "Todas las pantallas tiene que tener al menos un contenido.",
    "You can not exeed 200 chars in this field": "No puedes exceder los 200 caracteres en este campo.",
    "seconds": "segundos",
    "persons": "personas",
    "Day": "Día",
    "unknown": "Desconocido",
    "Print": "playout",
    "Prints": "playouts",
    "per print": "c/playout",
    "Results": "Resultado",
    "screen": "pantalla",
    "screens": "pantallas",
    "added": "agregada",
    "selected": "seleccionada",
    "Show all screens": "Mostrar todas las pantallas",
    "Hide Screens": "Ocultar Pantallas",
    "Some": "Algunas",
    "Payment method": "Método de pago",
    "Campaign": "Campaña",
    "All": "Todas",
    "Education": "Educación",
    "Entertainment": "Entretenimiento",
    "Services": "Servicios",
    "If you choose a DSP that is not LatinAd, you will only be able to make purchases in USD through an international invoice.": "Si seleccionas un DSP que no es LatinAd, solo podrás comprar en USD mediante factura internacional.",
    "Select country": "Seleccionar país",
    "and": "y",
    "ad": "anuncio",
    "ads": "anuncios",
    "row": "fila",
    "rows": "filas",
    "Previous page": "Anterior",
    "Next page": "Siguiente",
    // audience Dats Why
    "Female": "Mujeres",
    "Male": "Hombres",
    "Other": "Otro",
    "from 0 to 14": "de 0 a 14",
    "from 15 to 19": "de 15 a 19",
    "from 20 to 29": "de 20 a 29",
    "from 30 to 44": "de 30 a 44",
    "from 45 to 54": "de 45 a 54",
    "more than 55": "mas de 55",
    "Level_A": "Nivel A",
    "Level_B": "Nivel B",
    "Level_C": "Nivel C",
    "Level_D": "Nivel D",
    "Level_E": "Nivel E",
    "NOT_SPECIFIED": "NE",
    "Gender": "Género",
    "Age": "Edad",
    "Socioeconomic level": "Nivel socioeconómico",
    "Data obtained with the integration of": "Datos obtenidos con la integración de",
    "Audience Hyper-Insights that help you plan, monitor, and analyze Out of Home sites and campaigns to maximize ROI.": "Hyper-Insights de audiencias que te ayudan a planear, monitorear , analizar sitios y campañas Out of Home para maximizar el ROI.",
    "General": "General",
    "Qualitative": "Cualitativa",
    "By day of week": "Por día de la semana",
    "Quantitative audience": "Audiencia cuantitativa",
    "Qualitative audience": "Audiencia cualitativa",
    "Audience": "Audiencia",
    "Audience based on third-party measurement data": "Audiencia basada en datos de medición de terceros.",
    "Third audience": "Audiencia de terceros",
    "Dats Why audience": "Dats Why Audience",
    "Audience summary": "Resumen de audiencia",
    "Data per month in the radius of the screen location": "Datos por mes en el radio de la ubicación de la pantalla",
    "Total vehicle impressions": "Impresiones automóviles totales",
    "Unique vehicle impressions": "Impresiones automóviles únicas",
    "Frequency of unique people": "Frecuencia de personas únicas",
    "Total people impressions": "Impresiones personas totales",
    "Impressions on unique people": "Impresiones personas únicas",
    "Average exposure in seconds": "Exposición promedio en segundos",

    // 404
    "We look everywhere for the page": "Buscamos la página por todos lados",
    "(404 error)": "(Error 404)",
    "Go to LatinAd": "Ir a LatinAd",

    // Modal of currency - billing Conuntry
    "Language & Currency configuration": "Configuración de idioma y moneda",
    "Language": "Idioma",
    "International billing": "Factura Internacional",
    "Apply settings": "Aplicar configuración",
    "More": "Más",
    "Dates": "Fechas",
    "You will receive an international invoice without local taxes and the payment must be in USD (American Dollars) internationally.": "Recibirás una factura internacional sin impuestos locales y el pago deberá ser en USD (Dólares Americanos) de manera internacional. En caso de existir gastos/retenciones en concepto de WithHolding Taxes, correrán como concepto extra y estarán a cargo del anunciante",
    "Edition available on map": "Edicion disponible en mapa",
    "Currency change": "Cambio de moneda",
    "Currency change explanation": "Al cambiar la moneda puedes <strong>mantener el mismo monto</strong> de tu presupuesto sin conversión, o <strong>ajustarlo automáticamente</strong> según la tasa de cambio.",
    "Convert amount": "Convertir monto",
    "Keep original amount": "Conservar monto original",

    // POI - Points of interest
    "Bar & Coffee": "Bar & Café",
    "Beauty care": "Belleza",
    "Finance": "Finanzas",
    "Health": "Salud",
    "Institutions": "Instituciones",
    "Restaurants": "Restaurantes",
    "Shops": "Tiendas",
    "Transportation": "Transporte",
    "Vehicles": "Vehículos",

    // Info discount volume
    "2-7": "2 a 7 días",
    "8-15": "8 a 15 días",
    "16-28": "16 a 28 días",
    "29-60": "Desde 29 días",
    "Volume discount": "Descuento por volumen",
    "Discount applied": "Descuento aplicado",
    "Volume discount applied": "Descuento por volumen aplicado",
    "Increase n_diff_discount your campaign to access higher discounts": "Incrementa n_diff_discount tu campaña para acceder a mayores descuentos",
    "You already have all discounts applied!": "¡Ya tenés todos los descuentos aplicados!",
    "volume discount extraction limit": "Límite de extracción: <strong>{{limit}}</strong> playouts. Esta pantalla tiene descuentos por volumen activos, por lo que no es posible reducir más playouts.",
    "volume discount applied info": "Esta pantalla tiene <strong>descuento por volumen</strong> aplicado. Mínimo requerido: <strong>{{minSpots}}</strong> playouts/día para mantener el descuento.",
    "zero spots warning": "Para dejar una pantalla en 0 playouts primero tenés que marcarla como fuera de servicio o rechazada. Contactá al equipo de control de campaña.",
    "volume discount extraction limit impressions": "Límite de extracción: <strong>{{limit}}</strong> impresiones. Esta pantalla tiene descuentos por volumen activos, por lo que no es posible reducir más impresiones.",
    "volume discount extraction message impressions": "Esta pantalla tiene <strong>descuentos por volumen activos</strong>, por lo que no es posible reducir más impresiones una vez aplicados los descuentos.",
    "minimum investment extraction message impressions": "Esta pantalla tiene un <strong>mínimo de inversión</strong>. Tiene que mantener al menos <strong>{{minImpressions}}</strong> impresiones ({{minInvestment}}) durante la campaña, así que no es posible extraer por debajo de ese valor.",
    "volume discount applied info impressions": "Esta pantalla tiene <strong>descuento por volumen</strong> aplicado. Mínimo requerido: <strong>{{minImpressions}}</strong> impresiones/día para mantener el descuento.",
    "volume discount applied info total impressions": "Esta pantalla tiene <strong>descuento por volumen</strong> aplicado. Mínimo requerido: <strong>{{minImpressions}}</strong> impresiones totales para mantener el descuento.",
    "zero impressions warning": "Para dejar una pantalla en 0 impresiones primero tenés que marcarla como fuera de servicio o rechazada. Contactá al equipo de control de campaña.",
    "This screen has volume discounts configured, impressions will probably be added to it.": "Esta pantalla tiene descuentos por volumen configurado, probablemente se le agreguen impresiones.",

    // DiscountProgressBar
    "Add {{spots}} daily spots on this screen and get more benefits": "¡Sumá <spots>{{dailySpots}} playouts diarios</spots> ({{totalSpots}} en total) en esta pantalla y conseguí <span>más beneficios</span>!",
    "Add {{spots}} total spots on this screen and get more benefits": "¡Sumá <spots>{{totalSpots}} playouts totales</spots> en esta pantalla y conseguí <span>más beneficios</span>!",
    "Add {{impressions}} daily impressions on this screen and get more benefits": "¡Sumá <impressions>{{dailyImpressions}} impresiones diarias</impressions> ({{totalImpressions}} en total) en esta pantalla y conseguí <span>más beneficios</span>!",
    "Add {{impressions}} total impressions on this screen and get more benefits": "¡Sumá <impressions>{{totalImpressions}} impresiones totales</impressions> en esta pantalla y conseguí <span>más beneficios</span>!",
    "Add {{investment}} daily investment on this screen and get more benefits": "¡Sumá <investment>{{dailyInvestment}} diarios</investment> ({{totalInvestment}} en total) en esta pantalla y conseguí <span>más beneficios</span>!",
    "Add {{investment}} total investment on this screen and get more benefits": "¡Sumá <investment>{{totalInvestment}} de inversión total</investment> en esta pantalla y conseguí <span>más beneficios</span>!",
    "You reached the maximum benefits possible for this screen!": "¡Llegaste al máximo de beneficios posible para esta pantalla!",


    // subtype
    "Sub Type of screen": "Subtipo",
    "subtype_301": "Autopista",
    "subtype_302": "Ciudad",
    "subtype_303": "Parada de bus",
    "subtype_205": "Centro comercial",
    "subtype_101": "Aeropuerto",
    "subtype_105": "Subte",
    "subtype_106": "Estación de tren",
    "subtype_201": "Gasolinera",
    "subtype_202": "Tienda de conveniencia / Supermercado",
    "subtype_203": "Tienda de comestibles / Almacén / Kiosco",
    "subtype_207": "Farmacia",
    "subtype_401": "Gimnasio",
    "subtype_402": "Salón de belleza / Peluquería",
    "subtype_501": "Clínica",
    "subtype_601": "Escuela",
    "subtype_602": "Universidad",
    "subtype_701": "Centro Corporativo / Coworking",
    "subtype_801": "Club / Espacio recreativo",
    "subtype_804": "Bar",
    "subtype_805": "Restaurant",
    "subtype_1001": "Banco",
    "subtype_102": "Buses",
    "subtype_103": "Taxi (interior)",
    "subtype_104": "Taxi (exterior)",
    "subtype_10202": "Terminal",
    "subtype_204": "Licorería",
    "subtype_806": "Comida rápida",
    "subtype_1": "Tránsito",
    "subtype_2": "Retail",
    "subtype_3": "Outdoor",
    "subtype_4": "Salud y Belleza",
    "subtype_5": "Clínicas",
    "subtype_6": "Educación",
    "subtype_7": "Centro Corporativo / Coworking",
    "subtype_8": "Ocio",
    "subtype_9": "Gobierno",
    "subtype_10": "Entidad Financiera",
    "subtype_11": "Residencial",
    "venue_category_other": "Otros",

    //External DSP
    "info_dsp": "Al seleccionar un DSP distinto a Latinad el proceso de creación de deals puede demorar entre 3 a 6 horas para que queden activos, posteriormente estarán listo para su implementación en el DSP seleccionado.",
    "info_payment_first": "Al seleccionar un DSP distinto a Latinad",
    "info_payment_second": "el pago de la campaña no puede ejecutarse dentro de este sitio, deberá realizarse en la plataforma seleccionada.",
    "info_payment_third": "El monto a invertir en la campaña creada en Latinad puede no contener las comisiones del DSP elegido, lo que puede provocar que el valor total asignado deba ser mayor para contemplarlos.",

    // Verified agencies
    "Verified agency": "Agencia verificada",
    "Limited functionality": "Funcionalidad limitada",
    "Verified agencies text": "Para acceder a todas las funcionalidades exclusivas de la plataforma se requiere que las agencias estén verificadas. Para más información visite:",
    "The maximun duration of a traditional campaign for non-verfied agencies is limited to a week.": "La duración máxima de una campaña para una agencia no verificada es de una semana.",
    "Company is not verified and has more than $5000 USD in campaigns this month": "No es posible crear la campaña. La agencia no está verificada y ha gastado más de $5000 USD en campañas este mes.",
    "The maximum budget for non verified agencies is 5000 USD a month": "El presupuesto máximo de campañas programáticas para agencias no verificadas es de 5000USD al mes.",
    "Unverified media company info": "Tu empresa no está verificada. Al agregar pantallas externas en una campaña, la inversión se limitará a 5000 USD mensuales para campañas programáticas y la duración a una semana para campañas tradicionales.",
    "Unverified media company traditional limit": "Tu empresa no está verificada. Al agregar pantallas externas en una campaña tradicional, la duración se limita a una semana. Reducí la duración de la campaña o retirá las pantallas que no te pertenecen.",
    "Unverified media company programmatic limit": "Tu empresa no está verificada. La inversión mensual en pantallas externas no puede superar los 5000 USD. Reducí la inversión en pantallas que no te pertenecen.",

    //Bundles
    "Sales bundles": "Paquetes de ventas",
    "{{total}} sales bundle added": "{{total}} paquete de ventas agregado",
    "{{total}} sales bundles added": "{{total}} paquetes de ventas agregados",
    "The following sales bundles were added with all of their screens.": "Se agregaron los siguientes paquetes de venta con todas sus pantallas.",
    "Sales bundle": "Paquete de venta",
    "By name": "Por nombre",
    "Sales bundle details": "Detalles del paquete de ventas",
    "This screen belongs to the following bundles.": "Esta pantalla pertenece a los siguientes paquetes.",
    "Traditional price": "Precio tradicional",
    "Programmatic price": "Precio programático",
    "month": "mes",
    "Delete to selection": "Eliminar de la selección",
    "Number of screens": "Cantidad de pantallas",
    "Delete to cart": "Eliminar del carrito",
    "Type of bundle": "Tipo de paquete",
    "Displays of bundle": "Pantallas del paquete",
    "You can buy it only in a bundle (You will buy the entire bundle)": "Podés comprarla solo en paquete (Comprarás el paquete entero)",
    "You can buy it individually or as a sales bundle (You will buy the entire bundle)": "Podés comprarla individualmente o como paquete de ventas (Comprarás el paquete entero)",
    "This screen belongs to the following packages.": "Esta pantalla pertenece a los siguientes paquetes.",
    "When deleting this screen, the packages to which it belongs, as well as the screens associated with those packages, will be automatically removed from the selection.": "Al eliminar esta pantalla, se eliminarán automáticamente de la selección los paquetes a los que pertenece, así como las pantallas asociadas a dichos paquetes.",
    "Belongs to the following packages": "Pertenece a los siguientes paquetes",

    //Budget transfer
    "All displays": "Todas las pantallas",
    "Filter displays": "Filtrar pantallas",
    "Budget transfer": "Traspaso de presupuesto",
    "By Ad": "Por Anuncio",
    "By Display": "Por Pantalla",
    "Screen owners": "Media Owners",
    "Consumed spots": "Playouts consumidos",
    "Subtracted spots": "Playouts restados",
    "Added spots": "Playouts agregados",
    "Initial budget": "Presupuesto inicial",
    "Initial spots": "Playouts iniciales",
    "Available credit": "Crédito disponible para traspasar",
    "Apply changes": "Aplicar cambios",
    "Pending spots": "Playouts pendientes",
    "Budget": "Presupuesto",
    "You have available credit. You must use it to continue distributing.": "Tiene crédito disponible. Debe consumirlo para continuar distribuyendo",
    "Consumed credit. You can apply changes and edit. The remaining credit (n_credite) cannot be used to purchase 1 spot.": "Crédito consumido. Puede aplicar cambios y editar. El crédito sobrante (n_credite) no es posible consumirlo para la compra de 1 playout.",
    "Transfer the": "Traspasar el",
    "of outputs from": "de playouts de",
    "to": "a",
    "Origin Version": "Versión origen",
    "Destination Version": "Versión destino",
    "Origin Screen": "Pantalla origen",
    "Destination Screen": "Pantalla destino",
    "All spots are forwarded to this version": "Se traspasan todos los playouts a esta versión.",
    "Shows the remaining promised spots": "Muestra los playouts prometidos restantes",
    "CPM/spot": "CPM/playout",
    "Cost per spot": "Costo por playout",
    "Display {{displayName}} does not have {{version}}. Transfer was not applied.": "La pantalla {{displayName}} no tiene {{version}}. No se le realizó el traspaso.",
    "Pending impressions": "Impresiones pendientes",
    "Subtracted impressions": "Impresiones restadas",
    "Added impressions": "Impresiones agregadas",
    "of impressions from": "de impresiones de",
    "All impressions are forwarded to this version": "Se traspasan todas las impresiones a esta versión.",
    "Shows the remaining promised impressions": "Muestra las impresiones prometidas restantes",
    "CPM/impression": "CPM/impresión",
    "Cost per impression": "Costo por impresión",
    "Consumed credit. You can apply changes and edit. The remaining credit (n_credite) cannot be used to purchase more impressions.": "Crédito consumido. Podés aplicar cambios y editar. El crédito sobrante (n_credite) no alcanza para comprar más impresiones.",

    // Audience provider info
    "Audience data for these screens provided by": "Los datos de audiencia de estas pantallas son proporcionados por",
    "Audience data for this screen provided by": "Los datos de audiencia de esta pantalla son proporcionados por",
    "display owner": "el Media Owner",
    "Average audience by days of the week": "Audiencia promedio por días de la semana",
    "Average audience by hours": "Audiencia promedio por hora",
    "There is no audience data available": "No hay datos de audiencia disponibles",
    "There is no audience data for this screen": "No hay datos de audiencia para esta pantalla",
    "There is no audience data for these screens": "No hay datos de audiencia para estas pantallas",

    // Rules component
    "Rules": "Reglas",
    "Days of the week": "Días de la semana",
    "Create rules": "Crear reglas",
    "Assign spots": "Asignar",
    "Automatically assigns the entered output frequency to all screens.": "Asigna automáticamente la frecuencia de salida ingresada a todas las pantallas.",
    "Assign playouts tooltip": "Se distribuirán los playouts {{qualifier}} de forma equitativa entre los creativos, buscando mantener una frecuencia de exhibición similar. En campañas PMP, la frecuencia puede variar según la audiencia de cada pantalla.",
    "Impressions to assign": "Impresiones",
    "Rules in campaign": "Reglas en campaña",
    "Name of the rule": "Nombre de la regla",
    "Create new rules": "Crear reglas nuevas",
    "Rules applied in all campaign": "Reglas aplicadas en toda la campaña {{versions}}",
    "ruleAppliedAllVersions": "Regla aplicada en todo el anuncio {{versions}}",
    "ruleAppliedSomeVersions": "Regla aplicada en toda la campaña {{versions}} y otras pantallas, desplegar grupo para ver",
    "ruleAppliedSomeRelations": "Regla aplicada a alguna pantalla. Desplegar grupo para ver",
    "New rules": "Nuevas reglas",
    "Remove rule": "Quitar regla",
    "Set up rules in this display": "Configurar reglas en esta pantalla",
    "Set up rules in this spot": "Configurar reglas en este anuncio",
    "displays": "pantallas",
    "display": "pantalla",
    "spots": "anuncios",
    "impressions": "impresiones",
    "Spots": "Anuncios",
    "Spots Card": "Playouts",
    "Frequency": "Frecuencia",
    "Applying in display": "Aplicando en pantalla",
    "Applying in spot": "Aplicando en anuncio",
    "Applying in group": "Aplicando en grupo",
    "Applying in campaign": "Aplicando en campaña",
    "There are no general rules for this group": "No hay reglas generales para este grupo",
    "There are no general rules for this display": "No hay reglas generales para esta pantalla",
    "There are no rule for this spot": "No hay reglas para este anuncio",
    "Without rules in group": "Sin reglas en grupo",
    "Without rules in display": "Sin reglas en pantalla",
    "Without rules": "Sin reglas",
    "Rule(s) applied": "Regla(s) aplicada(s)",
    "Other applied rule(s)": "Otra(s) regla(s) aplicada(s)",
    "throughout the group": "en todo el grupo",
    "throughout the display": "en toda la pantalla",
    "Content name": "Nombre del contenido",
    "Spot resolution": "Resolución del anuncio",
    "Ad name": "Nombre del anuncio",
    "Not rules created": "No hay reglas creadas",
    "The name of the rule already exists": "El nombre de la regla ya existe",
    "The name of the rule is required": "El nombre de la regla es requerido",
    "Applied rule": "Regla aplicada",
    "Save": "Guardar",
    "Save and apply": "Guardar y aplicar",
    "You are about to permanently remove this rule from the list. This action cannot be undone": "Estás a punto de eliminar permanentemente esta regla de la lista. Esta acción no se puede deshacer",
    "Delete all campaign rules": "Eliminar todas las reglas de la campaña",
    "Are you sure you want to delete all rules? This action is irreversible": "¿Está seguro que desea eliminar todas las reglas? Esta acción es irreversible",

    // Screens Group
    "Removing this spot will redistribute the impressions among the remaining spots.": "Eliminando este anuncio redistribuirá los playouts entre los restantes.",
    "You are going to remove this screen from the campaign": "Al quitar esta pantalla, dejará de estar en la campaña. Puedes agregarla nuevamente desde el paso del mapa.",
    "The ad will be removed from the screen, and the spots will be redistributed among the other versions. You can add it again from the previous Ads step or by clicking the Add Ad button.": "Se quitará el anuncio de la pantalla y se redistribuirán los playouts entre las demás versiones. Puedes volver a agregarlo desde el paso anterior de Anuncios o dando al botón agregar anuncio.",
    "The ad will be removed from the screen, and the spots will be redistributed among the other versions. You can add it again from the previous Ads step or by clicking the Add Ad button._cpmi": "Se quitará el anuncio de la pantalla y se redistribuirán las impresiones entre las demás versiones. Puedes volver a agregarlo desde el paso anterior de Anuncios o dando al botón agregar anuncio.",
    "Are you sure you want to delete?": "¿Estás seguro de que quieres eliminar?",
    "You are going to remove this group of screens from the campaign": "Vas a quitar este grupo de pantallas de la campaña.",
    "Remove group of screens": "Quitar grupo de pantallas",
    "By removing the group, all screens within this group will be removed from the campaign.": "Al quitar el grupo, se quitarán de la campaña todas las pantallas que estén dentro de este grupo",
    "To delete need at least two group in the campaign": "Para eliminar se necesitan al menos dos grupos en la campaña",
    "Remove group": "Quitar grupo",
    "Investment of content": "Inversión de contenido",
    "Content version": "Versión de contenido",
    "Distribute by": "Distribuir por",
    "Total investment for this screen": "Inversión total para esta pantalla",
    "None": "Ninguna",
    "Countries": "Paises",
    "Province/State": "Estado/Provincia",
    "This screen does not accept contents of type": "Esta pantalla no acepta anuncios del tipo",
    "image": "imagen",
    "video": "video",
    "html": "html",
    "Balance impressions": "Balancear playouts",
    "Equalize the frequency across all screens, at the exact amount that keeps the campaign budget up to date.": "Igualar la frecuencia en todas las pantallas, en la cantidad exacta que mantiene actualizado el presupuesto de la campaña.",
    "You're about to equalize the spots across all screens, which will modify any previous spot distribution. Do you wish to continue?": "Estas por igualar los playouts en todas las pantallas, lo que modificará cualquier distribución previa de playouts ¿Deseas continuar?",
    "Balance playouts tooltip": "Se distribuirá la misma cantidad de playouts {{qualifier}} entre cada creativo, realizando un cálculo para mantener el presupuesto ajustado y buscando una frecuencia de exhibición similar. En campañas PMP, la frecuencia puede variar según la audiencia de cada pantalla.",
    "Confirm balance playouts body": "Estás por asignar playouts {{qualifier}} en todos los creativos por igual sin variar el presupuesto ajustado total, pero cualquier distribución previa de inversión e impresiones por creativo, pantalla o grupo se perderán. ¿Deseas continuar?",
    "Confirm balance playouts title": "Confirmar balanceo de frecuencia",
    "Balance": "Balancear",
    "Impressions will be distributed equally depending on the updated budget": "Se distribuirán los playouts equitativamente dependiendo del presupuesto actualizado",
    "When setting the amount for (n_type), it will not be modified during the automatic budget redistribution. It can be adjusted manually at any time.": "Al fijar el monto para {{n_type}}, este no se modificará durante la redistribución automática del presupuesto. Podrá ajustarse manualmente en cualquier momento.",
    "If the amount for (n_type) is not fixed, it may be modified during the automatic budget redistribution. It can also be adjusted manually at any time.": "Si el monto para {{n_type}} no está fijado, podrá modificarse durante la redistribución automática del presupuesto. También podrá ajustarse manualmente en cualquier momento.",
    "this display": "esta pantalla",
    "this spot": "este anuncio",
    "this displays group": "este grupo de pantallas",
    "Distributed by": "Distribuido por",
    "This indicates what percentage of the campaign’s total budget corresponds to the investment assigned to this group. You can modify it by editing either the investment or directly the percentage.": "Este indica el porcentaje del presupuesto total de la campaña que corresponde a la inversión asignada a este grupo. Puedes modificarlo editando la inversión o directamente el porcentaje.",
    "This indicates what percentage of the total budget allocated to this grouping corresponds to the investment assigned to this group. You can modify it by editing either the investment or directly the percentage.": "Esto indica a qué porcentaje del presupuesto total asignado a esta agrupación corrsponde la inversión asignada a este grupo. Puedes modificarla editando la inversión o directamenre el porcentaje.",
    "This indicates what percentage of the total budget allocated to the group corresponds to the investment assigned to this screen. You can modify it by editing either the investment or directly the percentage.": "Esto indica a qué porcentaje del presupuesto total asignado al grupo corresponde la inversión asignada a esta pantalla. Puedes modificarla editando la inversión o directamenre el porcentaje.",


    // CardCampaignStatusComponent
    "Campaign status": "Estado de la campaña",
    "Status": "Estado",
    "pending": "Pendiente",
    "approved": "Aprobada",
    "ready": "Activa",
    "cancelled_by_user": "Cancelada por el usuario",
    "cancelled": "Cancelada",
    "paused_status": "Pausada",
    "in progress": "En progreso",
    "Pause content": "Pausar contenido",
    "Resume content": "Reanudar contenido",
    "Pause campaign": "Pausar campaña",
    "Resume campaign": "Reanudar campaña",
    "Pause Display": "Pausar pantalla",
    "Resume Display": "Reanudar pantalla",

    // ContentSpecificationAlertComponent
    "Some content does not meet the specifications on one or more screens in this group": "Algunos anuncios no cumplen con las especificaciones en una o más pantallas de este grupo.",
    "Some content does not meet the specifications on this screen": "Algunos anuncios no cumplen con las especificaciones en esta pantalla",
    "Some content does not meet the specifications on one or more screens": "Algunos anuncios no cumplen con las especificaciones en una o mas pantallas",

    // ImageModalList
    "Number of ads on this screen": "Número de anuncios en esta pantalla",

    // CheckCompanyForUserComponent
    "Different companies": "Empresas diferentes",
    "The company logged into the system (n_company) does not match the one you have in the DSP (n_company_check). You will be redirected to avoid errors.": "La empresa logueada en el sistema (n_company) no coincide con la que tienes en el DSP (n_company_check). Se va redireccionar para no cometer errores.",

    // Error Boundary
    "An unexpected error has occurred": "Ocurrió un error inesperado",
    "To continue browsing, please press the button to return to the previous page. We are working to improve your experience on our platform. Thank you for your understanding!": "Para continuar navegando, por favor presiona el botón para regresar a la página anterior. Estamos trabajando para mejorar tu experiencia en nuestra plataforma. ¡Gracias por tu comprensión!",
    "Resume browsing": "Continuar navegando",
    "Clear caché": "Limpiar caché",

    //Modal new version
    "DISCOVER": "¡DESCUBRE",
    "the new way to": "la nueva manera de",
    "launch your": "lanzar tu",
    "CAMPAIGN!": "CAMPAÑA!",
    "Faster": "Más rápido",
    "Smarter": "Más inteligente",
    "Easier to use": "Más fácil de usar",
    "TRY THE NEW": "¡PRUEBA LA NUEVA",
    "VERSION NOW!": "VERSIÓN AHORA!",
    "View guide": "Ver guía",

    //Modal Change Dates
    "Attention Outbound rules updated automatically": "Atención: Reglas de salida actualizadas automáticamente",
    "You've edited the campaign's start and end dates. If the campaign has output rules configured, the dates for those rules have been automatically adjusted to match the new range.": "Has editado la fecha de inicio y fin de la campaña. Si la campaña tiene reglas de salida configuradas, las fechas de dichas reglas se han ajustado automáticamente para coincidir con el nuevo rango.",
    "However, we recommend reviewing these rules manually to ensure they remain aligned with your campaign goals.": "Sin embargo, te recomendamos revisar estas reglas manualmente para asegurarte de que siguen alineadas con los objetivos de la campaña.",

    // ChangeAdsModalComponent
    "Add ad": "Agregar anuncio",
    "Change ad": "Cambiar anuncio",
    "Expand ad to fill the screen": "Ampliar anuncio para llenar la pantalla",
    "Assign rule": "Asignar regla",
    "Are you sure you want to change this ad?": "¿Estás seguro de que quieres cambiar este anuncio?",
    "By selecting this option, the promised spots and remaining investment will be transferred to the new ad. The current ad will remain in 'Inactive' status and will retain the history of past spots. You can confirm to continue or cancel if you wish to keep the current ad.": "Al seleccionar esta opción, los playouts prometidos y la inversión restante se transferirán al nuevo anuncio. El anuncio actual quedará en estado 'Inactiv' y conservará el historial de los playouts ya realizados. Puedes confirmar para continuar o cancelar si deseas mantener el anuncio actual.",
    "Do you want to add this ad to the screen?": "¿Quieres agregar este anuncio a la pantalla?",
    "Upon confirmation, a new ad will be added as a new version within this screen. The remaining promised spots from other ads will be distributed equally among all active ads on the screen. If you prefer to allocate a specific number of spots to each ad, you can do so from the 'Edit Campaign' option.": "Al confirmar, se añadirá un nuevo anuncio como una nueva versión dentro de esta pantalla. Los playouts prometidos restantes de los demás anuncios se distribuirán equitativamente entre todos los anuncios activos de la pantalla. Si prefieres asignar una cantidad específica de playouts a cada anuncio, puedes hacerlo desde la opción 'Editar campaña'.",
    "I don't have my ads": "<strong>No tengo mi anuncio:</strong><br/>Si activas este botón, el anuncio quedará en estado \"en espera\", es decir que aún no cuentas con el anuncio para esta pantalla. Esto significa que no se enviará el mail de aprobación al Media Owner hasta que cargues el anuncio final y guardes los cambios.",
    "Pending ad": "<strong>Anuncio en espera:</strong><br/>Mientras este estado esté activo, no se enviará el mail de aprobación al Media Owner. Cuando reemplaces el anuncio por la versión final, este estado se desactivará automáticamente y se enviará el mail de aprobación correspondiente al momento de guardar los cambios.",

    // IA SMART PLANNER
    "Optimize": "Optimizar",
    "Optimize rules": "Optimizar reglas",
    "Optimizing campaign...": "Optimizando campaña...",

    // Optimize rules wizard
    "Rule type": "Tipo de regla",
    "Schedule": "Programación",
    "Min. hours": "Hs. mínimas",
    "Schedule mode": "Modo de programación",
    "Minimum active hours": "Horas mínimas activas",
    "Choose how to apply optimization rules across your screens": "Elegí cómo aplicar las reglas de optimización en tus pantallas",
    "General rule": "Regla general",
    "Apply the same rule to all campaign screens": "Aplica la misma regla a todas las pantallas de la campaña",
    "Individual rule": "Regla individual",
    "Create a separate rule for each screen": "Crea una regla separada para cada pantalla",
    "Group rule": "Regla por grupo",
    "Group screens by a common criteria": "Agrupa pantallas por un criterio común",
    "Select grouping criteria": "Seleccioná el criterio de agrupamiento",
    "Country": "País",
    "State / Province": "Provincia / Estado",
    "City": "Ciudad",
    "Company": "Empresa",
    "Choose the scheduling pattern for your rules": "Elegí el patrón de programación para tus reglas",
    "Weekly schedule": "Programación semanal",
    "One rule covering the entire week with the same time slots": "Una sola regla que cubre toda la semana con los mismos horarios",
    "Daily schedule": "Programación diaria",
    "Separate rules for each day of the week based on audience patterns": "Reglas separadas por día de la semana según los picos de audiencia",
    "Minimum active hours per day": "Horas mínimas activas por día",
    "Minimum active hours per week": "Horas mínimas activas por semana",
    "Calculate": "Calcular",
    "Optimization results": "Resultados de optimización",
    "Rules created": "Reglas creadas",
    "Estimated shows": "Playouts estimados",
    "Estimated reach": "Alcance estimado",
    "This action will replace all existing rules in the campaign": "Esta acción va a reemplazar todas las reglas existentes de la campaña",
    "Some screens have no audience data": "Algunas pantallas no tienen datos de audiencia",
    "The following screens could not be optimized": "Las siguientes pantallas no pudieron optimizarse por falta de datos de audiencia",
    "No rules could be created as no screens have audience data available": "No se pudieron crear reglas porque ninguna pantalla tiene datos de audiencia disponibles",
    "Apply rules": "Aplicar reglas",
    "Error optimizing rules": "Error al optimizar reglas",
    "No audience data available to optimize": "No hay datos de audiencia disponibles para optimizar",
    "Confirm optimization": "Confirmar optimización",
    "All existing rules in the campaign will be replaced with the optimized ones. Do you wish to continue?": "Se van a reemplazar todas las reglas existentes de la campaña con las optimizadas. ¿Deseás continuar?",

    // Screen replacement
    "Change ad title": "Cambiar anuncio",
    "Change ad button": "Cambiar anuncio",
    "When changing the ad, the current one will become inactive and the promised outputs that have not yet been executed will be assigned to the new ad, which will be incorporated as a new version within the same campaign.": "Al cambiar el anuncio, el actual quedará inactivo y los playouts prometidos que aún no se hayan ejecutado serán asignados al nuevo anuncio, el cual se incorporará como una nueva versión dentro de la misma campaña.",
    "This ad version is inactive and cannot be replaced": "Esta versión del anuncio está inactiva y no se puede sustituir",
    "This ad is inactive on all screens": "Este anuncio está inactivo en todas las pantallas",
    "This ad is linked to another screen. The change will only be made for this/these relationship(s) to avoid modifying the one currently in use. The current one will be deactivated and the promised outputs that have not yet been executed will be assigned to the new ad, which will be incorporated as a new version within the same campaign.": "Este anuncio se encuentra vinculado en otra pantalla. Se realizará el cambio sólo para esta/s relación/es para evitar modificar el que sigue en uso. El actual quedará inactivo y los playouts prometidos que aún no se hayan ejecutado serán asignados al nuevo anuncio, el cual se incorporará como una nueva versión dentro de la misma campaña.",
    "The selected version is inactive. Please select a valid version.": "La versión elegida está inactiva. Por favor selecciona una versión valida.",
    "You cannot replace the content of a screen that is inactive. Please select a valid version.": "No se puede reemplazar el contenido de una pantalla que está inactiva. Seleccione una versión válida.",
    "The new version has only been incorporated into those screens that had the previous version active.": "La nueva versión solo se ha incorporado en aquellas pantallas que tenían activa la versión anterior.",
    "The new ad does not match the resolution of any of the screens. No changes were made.": "El nuevo anuncio no se adapta a la resolución de ninguna de las pantallas. No se han realizado cambios.",
    "The ad was only changed on screens where the resolution matched. On the rest, the original version was kept.": "El anuncio solo se modificó en las pantallas cuya resolución coincidía. En el resto, se mantuvo la versión original.",
    "Apply tolerance": "Aplicar tolerancia",

    //Guaranteed DSP campaigns
    "Programmatic PMP": "Programática PMP",
    "Programmatic PG": "Programática PG",
    "Guaranteed Campaign": "Campaña Garantizada",
    "You guarantee the delivery of a defined number of screen appearances on specific dates and times. Inventory is reserved and the campaign takes priority to fulfill the contract, with total predictability.": "Asegura la entrega de una inversión definida en pantallas, fechas y horarios específicos. El inventario se reserva previamente y la campaña tiene prioridad de salida para cumplir lo contratado, ofreciendo total previsibilidad en la entrega.",
    "I have read and accept the terms and conditions of the Guaranteed Campaign.": "He leído y acepto los <a>términos y condiciones</a> de la Campaña Garantizada.",
    "You must accept the terms and conditions for a guaranteed campaign.": "Debes aceptar los términos y condiciones para una campaña garantizada.",
    "Guaranteed programmatic": "Programática garantizada",
    "Private agreement": "Acuerdo privado",
    "Campaign type": "Tipo de campaña",
    "Exchange": "Exchange",
    "Campaign created as guaranteed programmatic": "Campaña creada como programática garantizada",
    "Campaign created as a private agreement": "Campaña creada como acuerdo privado",
    "For guaranteed campaigns, only Magnite DSPs are permitted.": "Para campañas garantizadas solo se permiten DSPs de Magnite.",


    //NEW CHECKOUT
    "Programmatic campaign": "Campaña programática",
    "Finish proposal": "Finalizar Propuesta",
    "Amounts": "Montos",
    "Subtotal": "Subtotal",
    "Total budget": "Presupuesto total",
    "Planned impressions (%)": "Impresiones planificadas (%)",
    "Planned impressions percentage tooltip": "Porcentaje de impresiones alcanzada con el presupuesto entregado y CPM negociado. Cuando mayor sea la inversión, mayor el porcentaje de impresiones que podrás generar",
    "Maximum available impressions tooltip": "Impresiones máximas proyectadas considerando periodo, número de ubicaciones y frecuencia",
    "Age Range": "Rango de Edad",
    "Unique people frequency": "Frec. de personas únicas",
    "Projected reach": "Alcance proyectado",
    "Projected reach tooltip": "Cantidad proyectada de personas únicas expuestas a los anuncios de la campaña en el circuito de pantallas seleccionada durante el periodo seleccionado",
    "Investment by screen type": "Inversión por tipo de pantalla",
    "Investment distribution by screen type.": "Distribución de la inversión por tipo de pantalla.",
    "Investment by screen subtype": "Inversión por subtipo de pantalla",
    "Investment distribution by screen subtype.": "Distribución de la inversión por subtipo de pantalla.",
    "Investment by media owner": "Inversión por Media Owner",
    "Investment distribution by media owner (only visible to Super Admins).": "Distribución de la inversión por Media Owner (solo visible para Super Admins).",
    "Screen list ({count})": "Lista de pantallas",
    "Showing {{shown}} of {{total}}": "Mostrando {{shown}} de {{total}}",
    "Showing {{shown}} of {{total}} screens": "Mostrando {{shown}} de {{total}} pantallas",
    "Showing {{shown}} of {{total}} clients": "Mostrando {{shown}} de {{total}} clientes",
    "Spot": "Anuncio",
    "Screen": "Pantalla:",
    "Investment": "Inversión:",
    "Campaign performance": "Performance de la campaña",
    "Day of greatest reach": "Día de mayor alcance",
    "Day of the week with the highest projected reach.": "Día de la semana con mayor alcance proyectado.",
    "Highest reach day": "Mayor alcance día",
    "Total number of impressions on the best day.": "Número total de impresiones en el mejor día.",
    "Time of greatest reach": "Horario de mayor alcance",
    "Time slot with the highest projected reach.": "Franja horaria con mayor alcance proyectado.",
    "Highest hourly reach": "Mayor alcance por hora",
    "Number of impressions in the best time slot.": "Número de impresiones en la mejor franja horaria.",
    "No data available": "No hay datos disponibles.",
    "Save changes": "Guardar cambios",
    "Save & Pay": "Guardar y pagar",
    "Confirm & Pay": "Confirmar y pagar",

    //CAMPAIGN DATES
    "Attention: Review the impression rules.": "Atención: Revisá las reglas de impresiones.",
    "You have modified the campaign start and/or end date.": "Has modificado la fecha de inicio y/o fin de la campaña.",
    "The configured impression rules were automatically adjusted to match the new date range.": "Las reglas de impresiones configuradas se ajustaron automáticamente para coincidir con el nuevo rango de fechas.",
    "Important:": "Importante:",
    "We recommend manually reviewing the impression rules, especially the days of the week and time slots, to ensure they remain aligned with the campaign objective.": "Te recomendamos revisar manualmente las reglas de impresiones, especialmente los días de la semana y los horarios, para asegurarte de que sigan alineados con el objetivo de la campaña.",
    "Automatic adjustments do not take strategic planning changes into account.": "Los ajustes automáticos no contemplan cambios estratégicos de planificación.",

    // FILTERS 
    "No limits applied": "Sin límites aplicados",
    "Price range": "Rango de precios",
    "Purchase type": "Tipo de compra",
    "Per day": "Por día",
    "Per spot/output": "Por playout",
    "Per CPM impression": "Por cpm impresión",
    "From": "Desde",
    "To": "Hasta",
    "Screens": "Pantallas",
    "Type": "Tipo",
    "Subtype": "Subtipo",
    "Select": "Seleccionar",
    "Resolutions": "Resoluciones",
    "Other resolution": "Otra resolución",
    "Ad format": "Formato de anuncio",
    "Image": "Imagen",
    "Video": "Video",
    "HTML": "HTML",
    "Size": "Tamaño",
    "Small": "Chico",
    "Medium": "Mediano",
    "Large": "Grande",
    "Giant": "Gigante",
    "Circuit": "Circuito",
    "Ad duration range": "Rango de tiempo del anuncio",
    "Seconds": "Segundos",
    "Clear filters": "Limpiar filtros",
    "Apply": "Aplicar",
    "Media owner": "Media Owner",


    // NEW FILTERS DESIGN & LOGIC
    "General configuration": "Configuración general",
    "Filters": "Filtros",
    "Show all": "Mostrar todo",
    "Aspect ratio": "Relación de aspecto",
    "Resolution tooltip": "Selecciona resoluciones de la lista. Para añadir resoluciones personalizadas que no estén en la lista, escríbelas en el campo 'Otra resolución' separadas por comas (por ejemplo, 100x100, 200x200).",
    "Aspect ratio tooltip": "Si está habilitado, las pantallas se filtrarán coincidiendo con la relación de aspecto de las resoluciones seleccionadas dentro de la tolerancia definida. Si está deshabilitado, se ignorará la relación de aspecto.",
    "Unknown Media Owner": "Media Owner desconocido",
    "By activating this option, you confirm that the investment assigned to this company is secured and must be fulfilled by the end of the campaign.": "Al activar esta opción, confirmas que la inversión asignada a esta empresa está asegurada y debe cumplirse al finalizar la campaña.",
    "Secured investment.": "Inversión asegurada.",
    "Secured investment for this screen must be fulfilled by the end of the campaign.": "La inversión asegurada para esta pantalla debe cumplirse al finalizar la campaña.",
    "This medium works with secured investment.": "Este Media Owner trabaja bajo modalidad de pago asegurado, por lo que LatinAd se compromete a pagar el monto prometido. Se debe asegurar el compromiso de inversión de la agencia o anunciante. Siempre que sea posible, se deben generar campañas garantizadas cuando existan Media Owners con pagos asegurados.",
    "This screen is secured.": "Esta pantalla está asegurada.",
    "This group has screens with secured investment.": "En este grupo hay pantallas con inversión asegurada.",

    "View proposal": "Ver propuesta",
    "View proposal generated for this campaign": "Ver propuesta generada para esta campaña",
    "Tolerance tooltip": "Define el porcentaje de margen permitido al coincidir resoluciones de pantalla. Vacío equivale a 0%.",
    "Select the ads to add": "Seleccioná los anuncios a agregar",
    "Review of duplicate ads": "Revisión de anuncios duplicados",
    "Select all ads": "Seleccionar todos los anuncios",
    "Select all": "Seleccionar todo",
    "Zoom in to see the screens in a table": "Acercá el mapa para ver las pantallas en tabla",
    "If you select more than one ad per resolution, new versions will be created automatically.": "Si seleccionás más de un anuncio por resolución, se crearán nuevas versiones automáticamente.",
    "Keep all": "Mantener todos",
    "Add selected": "Agregar seleccionados",
    "You must select at least one ad per resolution": "Debés seleccionar al menos un anuncio por resolución",
    "You must select at least one ad": "Debés seleccionar al menos un anuncio",
    "ads added to campaign": "anuncios agregados",
    "new versions created": "versiones nuevas creadas",
    "Add all ads from folder": "Agregar todos los anuncios de la carpeta",
    "Select a folder to add all its ads": "Seleccioná una carpeta para agregar todos sus anuncios",
    "No content in folder": "No hay anuncios en esta carpeta",
    "Error loading folder contents": "Error al cargar los anuncios de la carpeta",
    "ads replaced": "anuncios reemplazados",
    "relations updated": "relaciones actualizadas",
    "contents omitted because target version is inactive": "anuncios omitidos porque su versión objetivo está inactiva",
    "Currently in campaign": "Actualmente en la campaña",
    "Selected ads will deactivate the current versions, preserving already delivered spots.": "Los anuncios seleccionados desactivarán las versiones actuales, conservando los playouts ya entregados.",
    "Selected ads will replace the current versions. Additional selections become new versions.": "Los anuncios seleccionados reemplazarán las versiones actuales. Las selecciones adicionales se agregan como nuevas versiones.",
    "All ads from this folder were already added in this session": "Todos los anuncios de esta carpeta ya fueron agregados en esta sesión",
    "ads omitted because no compatible display in approved campaign": "anuncios omitidos: ninguna pantalla compatible en la campaña aprobada",

    // CHATBOT IA SUPPORT
    "ChatbotSubtitle": "Tu copiloto de campaña",
    "ChatbotWelcome": "¡Hola! Soy tu asistente IA. Puedo ayudarte a agregar o eliminar pantallas, responder preguntas sobre tu carrito y cambiar datos de la campaña. ¿En qué te ayudo?",
    "ChatbotPlannerGreeting": "¡Hola! 👋 Estoy aquí para ayudarte.\n\nPuedes seleccionar una de las opciones disponibles a continuación para comenzar. También puedo acompañarte y guiarte durante el proceso.\n\nSi prefieres realizar el proceso manualmente, puedes cerrar este chat en cualquier momento.",
    "ChatbotMockReply": "Todavía me están configurando y aún no puedo realizar esa acción, pero pronto podré ayudarte con eso.",
    "Type a message": "Escribí un mensaje",
    "Add screens": "Agregar pantallas",
    "Remove screens": "Eliminar pantallas",
    "Summarize cart screens": "Resumir pantallas del carrito",
    "Change budget": "Cambiar presupuesto",
    "Change campaign data": "Cambiar datos de la campaña",
    "ChatbotReset": "Reiniciar chat",
    "ChatbotResetWarning": "La sesión está por expirar. Reiniciá el chat para continuar.",
    "ChatbotSessionExpired": "La sesión expiró. El historial fue reiniciado.",
    "ChatbotConfirm": "Confirmar",
    "ChatbotReject": "Rechazar",
    "ChatbotProposalAdd": "El asistente propone agregar estas pantallas:",
    "ChatbotProposalDelete": "El asistente propone eliminar estas pantallas:",
    "ChatbotProposalBudget": "El asistente propone cambiar el presupuesto:",
    "ChatbotProposalDates": "El asistente propone cambiar las fechas de la campaña:",
    "ChatbotProposalType": "El asistente propone cambiar el tipo de campaña:",
    "ChatbotProposalClient": "El asistente propone cambiar el cliente a:",
    "ChatbotProposalBrand": "El asistente propone cambiar la marca a:",
    "ChatbotProposalDsp": "El asistente propone cambiar el DSP externo a:",
    "ChatbotError": "Hubo un error. Por favor intentá de nuevo.",
    "Draw area to add screens": "Dibujar área para agregar pantallas",
    "Select area": "Seleccionar área",
    "Delete area": "Eliminar área",
}
